const electiveictQuestions = [
    {
      "question": "Which of the following software is commonly used for desktop publishing? (v1)",
      "options": [
        "Microsoft Excel",
        "Adobe InDesign",
        "Notepad",
        "Google Chrome"
      ],
      "answer": "Adobe InDesign"
    },
  {
    "question": "What is the primary function of an operating system?",
    "options": [
      "To create web pages",
      "To manage computer hardware and software resources",
      "To play video games",
      "To design spreadsheets"
    ],
    "answer": "To manage computer hardware and software resources"
  },
  {
    "question": "Which of the following is an example of a secondary storage device?",
    "options": [
      "RAM",
      "Cache memory",
      "Hard disk drive",
      "Processor"
    ],
    "answer": "Hard disk drive"
  },
  {
    "question": "Which symbol represents a decision in a flowchart?",
    "options": [
      "Oval",
      "Rectangle",
      "Diamond",
      "Circle"
    ],
    "answer": "Diamond"
  },
  {
    "question": "What is the main purpose of spreadsheet software?",
    "options": [
      "To draw images",
      "To manage numerical data",
      "To browse the internet",
      "To play music"
    ],
    "answer": "To manage numerical data"
  },
  {
    "question": "Which of the following is a function of utility software?",
    "options": [
      "Typing documents",
      "Creating animations",
      "Managing files and system resources",
      "Making presentations"
    ],
    "answer": "Managing files and system resources"
  },
  {
    "question": "Which HTML tag is used to insert a line break?",
    "options": [
      "<br>",
      "<break>",
      "<lb>",
      "<newline>"
    ],
    "answer": "<br>"
  },
  {
    "question": "What does the acronym HTML stand for?",
    "options": [
      "Hyperlink Text Markup Language",
      "High Text Machine Language",
      "Hyper Text Markup Language",
      "High Transmission Mark Language"
    ],
    "answer": "Hyper Text Markup Language"
  },
  {
    "question": "What component processes all the instructions in a computer?",
    "options": [
      "Hard disk",
      "RAM",
      "CPU",
      "Monitor"
    ],
    "answer": "CPU"
  },
  {
    "question": "Which of these is considered a non-impact printer?",
    "options": [
      "Dot matrix",
      "Daisy wheel",
      "Laser printer",
      "Line printer"
    ],
    "answer": "Laser printer"
  },
  {
    "question": "Which one is NOT a basic function of a database management system?",
    "options": [
      "Creating data",
      "Modifying data",
      "Playing music",
      "Deleting data"
    ],
    "answer": "Playing music"
  },
  {
    "question": "What is a byte made up of?",
    "options": [
      "2 bits",
      "4 bits",
      "8 bits",
      "16 bits"
    ],
    "answer": "8 bits"
  },
  {
    "question": "Which of the following best defines a network?",
    "options": [
      "A group of computers connected to share resources",
      "A group of people sharing food",
      "A single isolated computer",
      "A wireless speaker system"
    ],
    "answer": "A group of computers connected to share resources"
  },
  {
    "question": "Which one is a type of network topology?",
    "options": [
      "Line",
      "Circle",
      "Star",
      "Meshgrid"
    ],
    "answer": "Star"
  },
  {
    "question": "What is the function of antivirus software?",
    "options": [
      "To edit images",
      "To prevent and remove malicious software",
      "To create databases",
      "To make games"
    ],
    "answer": "To prevent and remove malicious software"
  },
  {
    "question": "Which of these languages is commonly used for website development?",
    "options": [
      "Python",
      "HTML",
      "Java",
      "Pascal"
    ],
    "answer": "HTML"
  },
  {
    "question": "What is the first stage in the program development life cycle?",
    "options": [
      "Coding",
      "Design",
      "Problem definition",
      "Testing"
    ],
    "answer": "Problem definition"
  },
  {
    "question": "What device is used to convert digital signals to analog and vice versa?",
    "options": [
      "Scanner",
      "Modem",
      "Router",
      "Hub"
    ],
    "answer": "Modem"
  },
  {
    "question": "Which of the following is a primary memory device?",
    "options": [
      "CD-ROM",
      "Hard disk",
      "RAM",
      "USB flash drive"
    ],
    "answer": "RAM"
  },
  {
    "question": "What does a flowchart help with?",
    "options": [
      "Typing essays",
      "Structuring algorithms visually",
      "Formatting documents",
      "Designing networks"
    ],
    "answer": "Structuring algorithms visually"
  },
  {
    "question": "Which storage media is optical?",
    "options": [
      "Flash drive",
      "CD-ROM",
      "Hard drive",
      "SSD"
    ],
    "answer": "CD-ROM"
  },
  {
    "question": "Which software is used to organize and analyze numerical data?",
    "options": [
      "Word processor",
      "Spreadsheet",
      "Presentation software",
      "Media player"
    ],
    "answer": "Spreadsheet"
  },
  {
    "question": "What does ICT stand for?",
    "options": [
      "Internet Computer Test",
      "Information and Communication Technology",
      "Internal Computing Technology",
      "Information Computer Transmission"
    ],
    "answer": "Information and Communication Technology"
  },
  {
    "question": "What type of software is Microsoft Word?",
    "options": [
      "Utility software",
      "System software",
      "Application software",
      "Programming language"
    ],
    "answer": "Application software"
  },
  {
    "question": "What is the function of the ALU in a CPU?",
    "options": [
      "Data storage",
      "Performing arithmetic and logical operations",
      "Displaying output",
      "Creating software"
    ],
    "answer": "Performing arithmetic and logical operations"
  },
  {
    "question": "Which of these is a data security measure?",
    "options": [
      "Data corruption",
      "Using strong passwords",
      "Password sharing",
      "Leaving computer open"
    ],
    "answer": "Using strong passwords"
  },
  {
    "question": "In database systems, what is a record?",
    "options": [
      "A single piece of data",
      "A complete set of fields in a row",
      "A column in a table",
      "A database query"
    ],
    "answer": "A complete set of fields in a row"
  },
  {
    "question": "Which application is best for creating brochures and flyers?",
    "options": [
      "Spreadsheet",
      "Web browser",
      "Desktop publishing software",
      "Word processor"
    ],
    "answer": "Desktop publishing software"
  },
  {
    "question": "Which of the following is an example of input device?",
    "options": [
      "Printer",
      "Monitor",
      "Scanner",
      "Speaker"
    ],
    "answer": "Scanner"
  },
  {
    "question": "Which language is closest to machine code?",
    "options": [
      "Assembly language",
      "Java",
      "C++",
      "Python"
    ],
    "answer": "Assembly language"
  },
  {
    "question": "What type of transmission media uses light to transfer data?",
    "options": [
      "Coaxial cable",
      "Fiber optic cable",
      "Twisted pair",
      "Radio wave"
    ],
    "answer": "Fiber optic cable"
  },
  {
    "question": "What feature in spreadsheets helps in quickly adding values?",
    "options": [
      "Insert",
      "Formula bar",
      "SUM function",
      "Gridlines"
    ],
    "answer": "SUM function"
  },
  {
    "question": "Which programming concept involves repetition?",
    "options": [
      "Variables",
      "Loops",
      "Arrays",
      "Input/output"
    ],
    "answer": "Loops"
  },
  {
    "question": "Which of these is a type of software license?",
    "options": [
      "Flash",
      "Open source",
      "FAT32",
      "BIOS"
    ],
    "answer": "Open source"
  },
  {
    "question": "Which of the following is a formatting task in spreadsheet?",
    "options": [
      "Creating formulas",
      "Inserting charts",
      "Changing font style",
      "Sorting data"
    ],
    "answer": "Changing font style"
  },
  {
    "question": "What does DTP stand for?",
    "options": [
      "Digital Test Processing",
      "Desktop Publishing",
      "Data Transmission Protocol",
      "Document Transfer Process"
    ],
    "answer": "Desktop Publishing"
  },
  {
    "question": "Which HTML tag is used to create a hyperlink?",
    "options": [
      "<link>",
      "<href>",
      "<a>",
      "<h>"
    ],
    "answer": "<a>"
  },
  {
    "question": "What is the purpose of using a database form?",
    "options": [
      "To create a new query",
      "To input and view data easily",
      "To design websites",
      "To edit spreadsheets"
    ],
    "answer": "To input and view data easily"
  },
  {
    "question": "Which part of a computer temporarily stores data while it's in use?",
    "options": [
      "Hard drive",
      "RAM",
      "ROM",
      "CD-ROM"
    ],
    "answer": "RAM"
  },
  {
    "question": "What is an algorithm?",
    "options": [
      "A coding language",
      "A programming tool",
      "A step-by-step problem-solving process",
      "A system unit"
    ],
    "answer": "A step-by-step problem-solving process"
  },
  {
    "question": "Which of the following is NOT a programming language?",
    "options": [
      "Python",
      "Java",
      "Scratch",
      "Windows"
    ],
    "answer": "Windows"
  },
  {
    "question": "What is the output of a computer?",
    "options": [
      "Data entered into the system",
      "Results produced after processing",
      "Storage medium",
      "Input signal"
    ],
    "answer": "Results produced after processing"
  },
  {
    "question": "What part of the CPU performs comparisons?",
    "options": [
      "CU",
      "ALU",
      "RAM",
      "ROM"
    ],
    "answer": "ALU"
  },
  {
    "question": "Which software helps recover deleted files?",
    "options": [
      "Video player",
      "File shredder",
      "Recovery utility",
      "Photo editor"
    ],
    "answer": "Recovery utility"
  },
  {
    "question": "Which media is commonly used for backups?",
    "options": [
      "RAM",
      "USB drive",
      "Cache",
      "ROM"
    ],
    "answer": "USB drive"
  },
  {
    "question": "Which is a key principle of publication design?",
    "options": [
      "Random font usage",
      "Cluttered layout",
      "Consistency",
      "Bright background noise"
    ],
    "answer": "Consistency"
  },
  {
    "question": "Which tool is used to search and retrieve data in a database?",
    "options": [
      "Form",
      "Query",
      "Table",
      "Field"
    ],
    "answer": "Query"
  },
  {
    "question": "What is a spreadsheet cell?",
    "options": [
      "A column label",
      "A row",
      "An intersection of a row and column",
      "A header"
    ],
    "answer": "An intersection of a row and column"
  },
  {
    "question": "Which of these is used to prevent unauthorized access to a network?",
    "options": [
      "Firewall",
      "Router",
      "Cable",
      "Hub"
    ],
    "answer": "Firewall"
  },
  {
    "question": "What does URL stand for?",
    "options": [
      "Universal Read Link",
      "Uniform Resource Locator",
      "United Routing Line",
      "User Reference Link"
    ],
    "answer": "Uniform Resource Locator"
  },
  {
    "question": "Which device is used to display visual output from a computer?",
    "options": [
      "Keyboard",
      "Monitor",
      "Mouse",
      "Printer"
    ],
    "answer": "Monitor"
  },
  {
    "question": "Which component stores the BIOS settings in a computer?",
    "options": [
      "RAM",
      "Hard drive",
      "CMOS battery",
      "CPU"
    ],
    "answer": "CMOS battery"
  },
  {
    "question": "Which of the following is a characteristic of ROM?",
    "options": [
      "It is volatile",
      "It stores data temporarily",
      "It is non-volatile",
      "It loses data when power is off"
    ],
    "answer": "It is non-volatile"
  },
  {
    "question": "What is the purpose of using a flowchart in programming?",
    "options": [
      "To write the code",
      "To delete bugs",
      "To visually represent an algorithm",
      "To store data"
    ],
    "answer": "To visually represent an algorithm"
  },
  {
    "question": "What is the extension for HTML files?",
    "options": [
      ".docx",
      ".html",
      ".txt",
      ".exe"
    ],
    "answer": ".html"
  },
  {
    "question": "Which of these is used to manipulate data in a database?",
    "options": [
      "Form",
      "Report",
      "Query",
      "Macro"
    ],
    "answer": "Query"
  },
  {
    "question": "Which media is commonly used to transfer large amounts of data physically?",
    "options": [
      "Bluetooth",
      "Wi-Fi",
      "USB drive",
      "Ethernet"
    ],
    "answer": "USB drive"
  },
  {
    "question": "What does the term 'booting' mean in computing?",
    "options": [
      "Shutting down the system",
      "Installing software",
      "Starting the operating system",
      "Running antivirus"
    ],
    "answer": "Starting the operating system"
  },
  {
    "question": "What is one main benefit of networking computers?",
    "options": [
      "Increasing system size",
      "Reducing performance",
      "Sharing resources",
      "Limiting access"
    ],
    "answer": "Sharing resources"
  },
  {
    "question": "What is a characteristic of optical storage?",
    "options": [
      "Uses magnetic field",
      "Has no moving parts",
      "Uses laser technology",
      "Stores data in RAM"
    ],
    "answer": "Uses laser technology"
  },
  {
    "question": "Which of these is used to protect against data loss?",
    "options": [
      "Firewall",
      "Backup",
      "Spyware",
      "Defragmenter"
    ],
    "answer": "Backup"
  },
  {
    "question": "In which software would you typically use formulas and functions?",
    "options": [
      "Word processor",
      "Spreadsheet",
      "Presentation",
      "Database"
    ],
    "answer": "Spreadsheet"
  },
  {
    "question": "What does the term 'multimedia' refer to?",
    "options": [
      "Only videos",
      "Only images",
      "A combination of text, audio, video, and animation",
      "Text and numbers only"
    ],
    "answer": "A combination of text, audio, video, and animation"
  },
  {
    "question": "Which of these is NOT a component of the CPU?",
    "options": [
      "ALU",
      "CU",
      "RAM",
      "Registers"
    ],
    "answer": "RAM"
  },
  {
    "question": "What is phishing?",
    "options": [
      "A fishing game",
      "An attempt to obtain sensitive information via deception",
      "Installing antivirus",
      "Fixing bugs in a program"
    ],
    "answer": "An attempt to obtain sensitive information via deception"
  },
  {
    "question": "Which of the following is a markup language?",
    "options": [
      "HTML",
      "Python",
      "C++",
      "PHP"
    ],
    "answer": "HTML"
  },
  {
    "question": "What is an example of a relational database system?",
    "options": [
      "Excel",
      "Access",
      "WordPad",
      "Photoshop"
    ],
    "answer": "Access"
  },
  {
    "question": "Which key is used to refresh a webpage in a browser?",
    "options": [
      "F4",
      "F5",
      "F2",
      "F11"
    ],
    "answer": "F5"
  },
  {
    "question": "What is the function of a compiler in programming?",
    "options": [
      "Executes the program line by line",
      "Edits the program",
      "Converts code to machine language",
      "Deletes errors"
    ],
    "answer": "Converts code to machine language"
  },
  {
    "question": "Which of these tools helps you design print materials like flyers?",
    "options": [
      "Spreadsheet",
      "Browser",
      "DTP software",
      "Presentation software"
    ],
    "answer": "DTP software"
  },
  {
    "question": "Which of these is an example of a utility program?",
    "options": [
      "Antivirus",
      "PowerPoint",
      "Excel",
      "Photoshop"
    ],
    "answer": "Antivirus"
  },
  {
    "question": "What is the main role of an input device?",
    "options": [
      "Display output",
      "Store data",
      "Send data to the computer",
      "Print documents"
    ],
    "answer": "Send data to the computer"
  },
  {
    "question": "Which of these HTML tags is used for headings?",
    "options": [
      "<p>",
      "<head>",
      "<h1> to <h6>",
      "<hl>"
    ],
    "answer": "<h1> to <h6>"
  },
  {
    "question": "Which part of the program development process involves testing the software?",
    "options": [
      "Planning",
      "Designing",
      "Implementation",
      "Debugging"
    ],
    "answer": "Debugging"
  },
  {
    "question": "Which tool can be used to analyze data in a spreadsheet?",
    "options": [
      "Filter",
      "Hyperlink",
      "Header",
      "Table of contents"
    ],
    "answer": "Filter"
  },
  {
    "question": "What kind of device is a joystick?",
    "options": [
      "Output device",
      "Input device",
      "Storage device",
      "Network device"
    ],
    "answer": "Input device"
  },
  {
    "question": "What is a macro in a spreadsheet?",
    "options": [
      "A graphic tool",
      "A large formula",
      "A recording of steps to automate tasks",
      "An error"
    ],
    "answer": "A recording of steps to automate tasks"
  },
  {
    "question": "Which of these is an example of primary storage?",
    "options": [
      "Flash drive",
      "Hard disk",
      "RAM",
      "DVD"
    ],
    "answer": "RAM"
  },
  {
    "question": "What is the role of the Control Unit in the CPU?",
    "options": [
      "Performs mathematical operations",
      "Stores data",
      "Directs operations of the processor",
      "Displays output"
    ],
    "answer": "Directs operations of the processor"
  },
  {
    "question": "Which one of the following is a logical operator?",
    "options": [
      "+",
      "-",
      "AND",
      "*"
    ],
    "answer": "AND"
  },
  {
    "question": "Which of these is a step in creating a database?",
    "options": [
      "Building a web page",
      "Inserting audio",
      "Defining fields and records",
      "Editing images"
    ],
    "answer": "Defining fields and records"
  },
  {
    "question": "What is the result of 2 + 3 * 4 in a spreadsheet without parentheses?",
    "options": [
      "20",
      "14",
      "24",
      "10"
    ],
    "answer": "14"
  },
  {
    "question": "Which of the following HTML tags is used to insert an image?",
    "options": [
      "<img>",
      "<src>",
      "<pic>",
      "<media>"
    ],
    "answer": "<img>"
  },
  {
    "question": "What type of network spans a single building?",
    "options": [
      "MAN",
      "LAN",
      "WAN",
      "PAN"
    ],
    "answer": "LAN"
  },
  {
    "question": "Which device can be used to connect multiple networks together?",
    "options": [
      "Switch",
      "Router",
      "Hub",
      "Bridge"
    ],
    "answer": "Router"
  },
  {
    "question": "Which of the following is NOT an output device?",
    "options": [
      "Monitor",
      "Speaker",
      "Keyboard",
      "Printer"
    ],
    "answer": "Keyboard"
  },
  {
    "question": "Which protocol is used to transfer web pages?",
    "options": [
      "SMTP",
      "FTP",
      "HTTP",
      "IP"
    ],
    "answer": "HTTP"
  },
  {
    "question": "Which feature allows combining multiple data sources in a spreadsheet?",
    "options": [
      "Merge cells",
      "Sort",
      "Pivot table",
      "Filter"
    ],
    "answer": "Pivot table"
  },
  {
    "question": "What type of data is TRUE or FALSE?",
    "options": [
      "String",
      "Integer",
      "Boolean",
      "Character"
    ],
    "answer": "Boolean"
  },
  {
    "question": "Which component stores permanent data and is read-only?",
    "options": [
      "RAM",
      "ROM",
      "Cache",
      "Register"
    ],
    "answer": "ROM"
  },
  {
    "question": "Which of these is a benefit of using presentation software?",
    "options": [
      "Compiling code",
      "Visualizing data",
      "Installing operating systems",
      "Running background processes"
    ],
    "answer": "Visualizing data"
  },
  {
    "question": "What does a database report do?",
    "options": [
      "Stores formulas",
      "Displays formatted output from a database",
      "Creates queries",
      "Sorts the records"
    ],
    "answer": "Displays formatted output from a database"
  },
  {
    "question": "Which of these HTML tags defines a table row?",
    "options": [
      "<td>",
      "<tr>",
      "<th>",
      "<tb>"
    ],
    "answer": "<tr>"
  },
  {
    "question": "Which application is best used for preparing presentations?",
    "options": [
      "Access",
      "PowerPoint",
      "Excel",
      "Word"
    ],
    "answer": "PowerPoint"
  },
  {
    "question": "Which of these is a type of network topology?",
    "options": [
      "Circular",
      "Star",
      "Linear",
      "Hexagon"
    ],
    "answer": "Star"
  },
  {
    "question": "Which part of a spreadsheet displays the name of the selected cell?",
    "options": [
      "Formula bar",
      "Cell",
      "Name box",
      "Sheet tab"
    ],
    "answer": "Name box"
  },
  {
    "question": "Which of the following is a key step in diagnosing a faulty PC?",
    "options": [
      "Reinstalling Word",
      "Formatting spreadsheet",
      "Running hardware diagnostics",
      "Clearing clipboard"
    ],
    "answer": "Running hardware diagnostics"
  },
  {
    "question": "Which HTML tag is used to create a hyperlink?",
    "options": [
      "<a>",
      "<link>",
      "<href>",
      "<url>"
    ],
    "answer": "<a>"
  },
  {
    "question": "Which of the following is considered secondary storage?",
    "options": [
      "ROM",
      "RAM",
      "Hard Disk",
      "Register"
    ],
    "answer": "Hard Disk"
  },
  {
    "question": "Which one is NOT a database object?",
    "options": [
      "Form",
      "Query",
      "Macro",
      "Worksheet"
    ],
    "answer": "Worksheet"
  },
  {
    "question": "Which device is used to digitize a physical document?",
    "options": [
      "Scanner",
      "Printer",
      "Monitor",
      "Speaker"
    ],
    "answer": "Scanner"
  },
  {
    "question": "Which type of software helps organize and manage data?",
    "options": [
      "Operating System",
      "Spreadsheet",
      "Database",
      "Utility"
    ],
    "answer": "Database"
  },
  {
    "question": "What is the first step in the Program Development Life Cycle?",
    "options": [
      "Design",
      "Analysis",
      "Testing",
      "Coding"
    ],
    "answer": "Analysis"
  },
  {
    "question": "Which of the following is an example of system software?",
    "options": [
      "Microsoft Word",
      "Google Chrome",
      "Windows 10",
      "CorelDraw"
    ],
    "answer": "Windows 10"
  },
  {
    "question": "Which of these is not a basic operation of a computer?",
    "options": [
      "Input",
      "Process",
      "Storing",
      "Painting"
    ],
    "answer": "Painting"
  },
  {
    "question": "What is the purpose of headers and footers in a document?",
    "options": [
      "To add background color",
      "To insert hyperlinks",
      "To add information at the top and bottom of pages",
      "To change font size"
    ],
    "answer": "To add information at the top and bottom of pages"
  },
  {
    "question": "Which file format is used for web page files?",
    "options": [
      ".exe",
      ".html",
      ".doc",
      ".xlsx"
    ],
    "answer": ".html"
  },
  {
    "question": "What type of chart is best for showing proportions?",
    "options": [
      "Bar chart",
      "Line chart",
      "Pie chart",
      "Histogram"
    ],
    "answer": "Pie chart"
  },
  {
    "question": "Which of the following can help prevent unauthorized access to a computer?",
    "options": [
      "Password",
      "Mouse",
      "Scanner",
      "Monitor"
    ],
    "answer": "Password"
  },
  {
    "question": "What does GUI stand for?",
    "options": [
      "Graphical User Interface",
      "Global Unit Integration",
      "General User Input",
      "Graphic Unified Instruction"
    ],
    "answer": "Graphical User Interface"
  },
  {
    "question": "Which tag in HTML is used to create a line break?",
    "options": [
      "<lb>",
      "<br>",
      "<break>",
      "<newline>"
    ],
    "answer": "<br>"
  },
  {
    "question": "Which of the following is a computer language?",
    "options": [
      "English",
      "French",
      "Python",
      "Portuguese"
    ],
    "answer": "Python"
  },
  {
    "question": "What does DTP stand for?",
    "options": [
      "Direct Transfer Protocol",
      "Desktop Publishing",
      "Digital Text Processor",
      "Data Transfer Page"
    ],
    "answer": "Desktop Publishing"
  },
  {
    "question": "Which of the following is NOT a storage device?",
    "options": [
      "Hard disk",
      "Flash drive",
      "RAM",
      "CPU"
    ],
    "answer": "CPU"
  },
  {
    "question": "In which type of network is each computer equal?",
    "options": [
      "Client-server",
      "Peer-to-peer",
      "Hybrid",
      "WAN"
    ],
    "answer": "Peer-to-peer"
  },
  {
    "question": "What kind of device is a webcam?",
    "options": [
      "Output device",
      "Input device",
      "Storage device",
      "Processing device"
    ],
    "answer": "Input device"
  },
  {
    "question": "Which command is used to remove a file permanently from a computer?",
    "options": [
      "Save",
      "Delete",
      "Cut",
      "Rename"
    ],
    "answer": "Delete"
  },
  {
    "question": "Which one is not an operating system?",
    "options": [
      "Windows",
      "Linux",
      "Excel",
      "macOS"
    ],
    "answer": "Excel"
  },
  {
    "question": "Which of the following is used to store data permanently?",
    "options": [
      "Cache",
      "RAM",
      "Hard Drive",
      "Register"
    ],
    "answer": "Hard Drive"
  },
  {
    "question": "Which menu is commonly used to change the font in word processing software?",
    "options": [
      "File",
      "Edit",
      "Format",
      "Tools"
    ],
    "answer": "Format"
  },
  {
    "question": "Which of these software types assists in managing files and folders?",
    "options": [
      "Utility Software",
      "Game Software",
      "Compiler",
      "Presentation Software"
    ],
    "answer": "Utility Software"
  },
  {
    "question": "Which storage device is optical?",
    "options": [
      "DVD",
      "Hard Disk",
      "Flash Drive",
      "SSD"
    ],
    "answer": "DVD"
  },
  {
    "question": "Which of the following is a step in formatting a worksheet?",
    "options": [
      "Writing a report",
      "Inserting a footer",
      "Changing font color",
      "Saving database"
    ],
    "answer": "Changing font color"
  },
  {
    "question": "Which programming structure makes decisions based on conditions?",
    "options": [
      "Loop",
      "Sequence",
      "Selection",
      "Array"
    ],
    "answer": "Selection"
  },
  {
    "question": "What is the use of a form in a database?",
    "options": [
      "To query the database",
      "To store large amounts of data",
      "To enter and view data",
      "To delete tables"
    ],
    "answer": "To enter and view data"
  },
  {
    "question": "Which software is used to create animations and simulations in education?",
    "options": [
      "Word processor",
      "Spreadsheet",
      "Multimedia software",
      "DTP software"
    ],
    "answer": "Multimedia software"
  },
  {
    "question": "Which programming term describes a step-by-step process to solve a problem?",
    "options": [
      "Code",
      "Syntax",
      "Algorithm",
      "Loop"
    ],
    "answer": "Algorithm"
  },
  {
    "question": "What is the shortcut key for 'Copy'?",
    "options": [
      "Ctrl + V",
      "Ctrl + X",
      "Ctrl + C",
      "Ctrl + Z"
    ],
    "answer": "Ctrl + C"
  },
  {
    "question": "Which key on the keyboard is used to delete characters to the right?",
    "options": [
      "Backspace",
      "Ctrl",
      "Shift",
      "Delete"
    ],
    "answer": "Delete"
  },
  {
    "question": "Which database object is designed for printing data?",
    "options": [
      "Form",
      "Query",
      "Report",
      "Macro"
    ],
    "answer": "Report"
  },
  {
    "question": "Which one of the following is a valid email address?",
    "options": [
      "james@site",
      "www.james.com",
      "james@site.com",
      "james#site.com"
    ],
    "answer": "james@site.com"
  },
  {
    "question": "What does ISP stand for?",
    "options": [
      "International Software Program",
      "Internet Service Provider",
      "Internal System Protocol",
      "Internet Software Page"
    ],
    "answer": "Internet Service Provider"
  },
  {
    "question": "What is malware?",
    "options": [
      "A kind of printer",
      "Helpful program",
      "Malicious software",
      "An antivirus"
    ],
    "answer": "Malicious software"
  },
  {
    "question": "Which file type is commonly used for presentations?",
    "options": [
      ".pptx",
      ".mp3",
      ".txt",
      ".jpg"
    ],
    "answer": ".pptx"
  },
  {
    "question": "Which of the following is an example of a web browser?",
    "options": [
      "Yahoo",
      "Outlook",
      "Google Chrome",
      "Bing"
    ],
    "answer": "Google Chrome"
  },
  {
    "question": "Which component connects a computer to the internet?",
    "options": [
      "Modem",
      "RAM",
      "Monitor",
      "Mouse"
    ],
    "answer": "Modem"
  },
  {
    "question": "What is the term for unauthorized copying of software?",
    "options": [
      "Debugging",
      "Piracy",
      "Hacking",
      "Spamming"
    ],
    "answer": "Piracy"
  },
  {
    "question": "What is the main function of a spreadsheet?",
    "options": [
      "To browse the internet",
      "To store audio files",
      "To perform calculations and data analysis",
      "To edit videos"
    ],
    "answer": "To perform calculations and data analysis"
  },
  {
    "question": "Which tool is used to find and correct spelling errors in documents?",
    "options": [
      "Spell Check",
      "Format Painter",
      "Thesaurus",
      "Mail Merge"
    ],
    "answer": "Spell Check"
  },
  {
    "question": "Which tag is used in HTML to create an unordered list?",
    "options": [
      "<ol>",
      "<ul>",
      "<li>",
      "<list>"
    ],
    "answer": "<ul>"
  },
  {
    "question": "Which of these is NOT a function of a network?",
    "options": [
      "Sharing resources",
      "Data transmission",
      "Securing passwords",
      "Collaborative work"
    ],
    "answer": "Securing passwords"
  },
  {
    "question": "Which of the following is the central component of a computer?",
    "options": [
      "Mouse",
      "CPU",
      "Monitor",
      "Keyboard"
    ],
    "answer": "CPU"
  },
 {
    "question": "Which of the following is not a type of network topology?",
    "options": [
      "Star",
      "Bus",
      "Circle",
      "Ring"
    ],
    "answer": "Circle"
  },
  {
    "question": "Which of these represents binary data?",
    "options": [
      "ABCD",
      "1234",
      "0101",
      "True/False"
    ],
    "answer": "0101"
  },
  {
    "question": "Which application is best for creating a school magazine?",
    "options": [
      "Spreadsheet",
      "Database",
      "Word Processor",
      "Desktop Publishing"
    ],
    "answer": "Desktop Publishing"
  },
  {
    "question": "What is the primary role of the CPU?",
    "options": [
      "Input data",
      "Process data",
      "Store data",
      "Display data"
    ],
    "answer": "Process data"
  },
  {
    "question": "Which HTML tag is used for inserting an image?",
    "options": [
      "<image>",
      "<img>",
      "<pic>",
      "<src>"
    ],
    "answer": "<img>"
  },
  {
    "question": "What is an example of volatile memory?",
    "options": [
      "ROM",
      "Flash Drive",
      "RAM",
      "Hard Disk"
    ],
    "answer": "RAM"
  },
  {
    "question": "Which of these is a function in a spreadsheet?",
    "options": [
      "SUM()",
      "INSERT()",
      "DISPLAY()",
      "FONT()"
    ],
    "answer": "SUM()"
  },
  {
    "question": "Which software would be used to manipulate numbers and perform calculations?",
    "options": [
      "Word Processor",
      "Spreadsheet",
      "DTP",
      "Browser"
    ],
    "answer": "Spreadsheet"
  },
  {
    "question": "What type of media is a USB flash drive?",
    "options": [
      "Optical",
      "Magnetic",
      "Solid-state",
      "Paper"
    ],
    "answer": "Solid-state"
  },
  {
    "question": "Which HTML element is used to make text bold?",
    "options": [
      "<b>",
      "<bold>",
      "<strong>",
      "<bt>"
    ],
    "answer": "<b>"
  },
  {
    "question": "What is the purpose of an algorithm in programming?",
    "options": [
      "To print text",
      "To solve problems logically",
      "To compile code",
      "To store data"
    ],
    "answer": "To solve problems logically"
  },
  {
    "question": "Which of these is not a type of computer?",
    "options": [
      "Desktop",
      "Mainframe",
      "Notebook",
      "Mechanical"
    ],
    "answer": "Mechanical"
  },
  {
    "question": "What is a key feature of DTP software?",
    "options": [
      "Programming tools",
      "Database tables",
      "Page layout design",
      "Spreadsheets"
    ],
    "answer": "Page layout design"
  },
  {
    "question": "Which of the following is a type of primary memory?",
    "options": [
      "SSD",
      "Hard disk",
      "RAM",
      "CD-ROM"
    ],
    "answer": "RAM"
  },
  {
    "question": "What is the full meaning of HTML?",
    "options": [
      "Hyper Tool Markup Language",
      "Hypertext Markup Language",
      "HighText Machine Language",
      "Hyper Transfer Markup Language"
    ],
    "answer": "Hypertext Markup Language"
  },
  {
    "question": "Which symbol is used for cell referencing in Excel?",
    "options": [
      "!",
      "#",
      "$",
      "@"
    ],
    "answer": "$"
  },
  {
    "question": "Which of the following is used to protect data from unauthorized access?",
    "options": [
      "Password",
      "Monitor",
      "Printer",
      "Speaker"
    ],
    "answer": "Password"
  },
  {
    "question": "Which of the following is a programming language?",
    "options": [
      "Spreadsheet",
      "Python",
      "DTP",
      "HTML"
    ],
    "answer": "Python"
  },
  {
    "question": "What is a flowchart used for?",
    "options": [
      "Storing data",
      "Drawing pictures",
      "Visualizing program logic",
      "Measuring speed"
    ],
    "answer": "Visualizing program logic"
  },
  {
    "question": "Which of these is not a secondary storage device?",
    "options": [
      "CD",
      "Flash Drive",
      "Hard Disk",
      "ROM"
    ],
    "answer": "ROM"
  },
  {
    "question": "Which device allows a computer to connect to a network?",
    "options": [
      "Modem",
      "Monitor",
      "Scanner",
      "Keyboard"
    ],
    "answer": "Modem"
  },
  {
    "question": "In databases, what is a query used for?",
    "options": [
      "Input data",
      "Format reports",
      "Retrieve data",
      "Print data"
    ],
    "answer": "Retrieve data"
  },
  {
    "question": "Which of the following tags is used to insert a table in HTML?",
    "options": [
      "<table>",
      "<tbl>",
      "<td>",
      "<tr>"
    ],
    "answer": "<table>"
  },
  {
    "question": "Which of the following is an example of utility software?",
    "options": [
      "Antivirus",
      "Photoshop",
      "PowerPoint",
      "Google Chrome"
    ],
    "answer": "Antivirus"
  },
  {
    "question": "What does the acronym ICT stand for?",
    "options": [
      "Information and Computer Technology",
      "Information and Communication Technology",
      "Internet and Communication Tool",
      "Information Controlled Technology"
    ],
    "answer": "Information and Communication Technology"
  },
  {
    "question": "Which function in Excel returns the largest number in a range?",
    "options": [
      "MAX()",
      "LARGE()",
      "BIG()",
      "TOP()"
    ],
    "answer": "MAX()"
  },
  {
    "question": "Which key opens the Start menu in Windows?",
    "options": [
      "Alt",
      "Ctrl",
      "Esc",
      "Windows"
    ],
    "answer": "Windows"
  },
  {
    "question": "Which device is used for output?",
    "options": [
      "Mouse",
      "Monitor",
      "Microphone",
      "Scanner"
    ],
    "answer": "Monitor"
  },
  {
    "question": "Which of the following is a feature of spreadsheets?",
    "options": [
      "Data Entry",
      "Photo Editing",
      "Video Compression",
      "Sound Recording"
    ],
    "answer": "Data Entry"
  },
  {
    "question": "Which of these is a basic component of a database?",
    "options": [
      "Slide",
      "Table",
      "Layout",
      "Animation"
    ],
    "answer": "Table"
  },
  {
    "question": "Which of the following is not a programming phase?",
    "options": [
      "Analysis",
      "Testing",
      "Photoshopping",
      "Coding"
    ],
    "answer": "Photoshopping"
  },
  {
    "question": "What does the <tr> tag in HTML represent?",
    "options": [
      "Text Row",
      "Table Row",
      "Table Report",
      "Title Row"
    ],
    "answer": "Table Row"
  },
  {
    "question": "Which storage type is best for fast access and low power consumption?",
    "options": [
      "Hard Disk",
      "DVD",
      "SSD",
      "CD-ROM"
    ],
    "answer": "SSD"
  },
  {
    "question": "What is a virus in computing?",
    "options": [
      "A computer user",
      "A harmful program",
      "A software update",
      "A web browser"
    ],
    "answer": "A harmful program"
  },
  {
    "question": "Which of the following is used to insert charts in Excel?",
    "options": [
      "Home tab",
      "Insert tab",
      "Data tab",
      "Review tab"
    ],
    "answer": "Insert tab"
  },
  {
    "question": "What is the purpose of data validation in spreadsheets?",
    "options": [
      "To calculate totals",
      "To prevent incorrect data entry",
      "To sort rows",
      "To print graphs"
    ],
    "answer": "To prevent incorrect data entry"
  },
  {
    "question": "Which software would be best to prepare a brochure?",
    "options": [
      "Spreadsheet",
      "DTP",
      "Browser",
      "Database"
    ],
    "answer": "DTP"
  },
  {
    "question": "Which of the following is NOT a programming language?",
    "options": [
      "Python",
      "C++",
      "HTML",
      "Excel"
    ],
    "answer": "Excel"
  },
  {
    "question": "What is the main function of database management systems?",
    "options": [
      "Play music",
      "Store and manage data",
      "Display pictures",
      "Control internet access"
    ],
    "answer": "Store and manage data"
  },
  {
    "question": "What kind of data type would you use to store text?",
    "options": [
      "Integer",
      "String",
      "Float",
      "Boolean"
    ],
    "answer": "String"
  },
  {
    "question": "Which of the following can be used to design web pages?",
    "options": [
      "PowerPoint",
      "HTML",
      "Photoshop",
      "Word"
    ],
    "answer": "HTML"
  },
  {
    "question": "What is one main advantage of using a network?",
    "options": [
      "Faster typing",
      "Data sharing",
      "Better graphics",
      "More power"
    ],
    "answer": "Data sharing"
  },
  {
    "question": "Which of the following tags is used to define a table header in HTML?",
    "options": [
      "<th>",
      "<tr>",
      "<td>",
      "<thead>"
    ],
    "answer": "<th>"
  },
  {
    "question": "Which feature in a spreadsheet allows repetitive calculations?",
    "options": [
      "Formula",
      "Chart",
      "Cell shading",
      "Row height"
    ],
    "answer": "Formula"
  },
  {
    "question": "What is the main purpose of educational technology?",
    "options": [
      "To teach coding",
      "To improve learning",
      "To play games",
      "To create videos"
    ],
    "answer": "To improve learning"
  },
  {
    "question": "Which one is an input device?",
    "options": [
      "Monitor",
      "Speaker",
      "Mouse",
      "Projector"
    ],
    "answer": "Mouse"
  },
  {
    "question": "Which component processes all instructions in a computer?",
    "options": [
      "RAM",
      "Motherboard",
      "CPU",
      "Hard Disk"
    ],
    "answer": "CPU"
  },
  {
    "question": "Which of the following is a programming paradigm?",
    "options": [
      "Linear",
      "Sequential",
      "Object-Oriented",
      "Relational"
    ],
    "answer": "Object-Oriented"
  },
  {
    "question": "Which command is used to save a file in most applications?",
    "options": [
      "Ctrl + P",
      "Ctrl + C",
      "Ctrl + S",
      "Ctrl + Z"
    ],
    "answer": "Ctrl + S"
  },
  {
    "question": "What does GUI stand for?",
    "options": [
      "General User Interface",
      "Graphical User Interface",
      "Graphical Utility Interface",
      "Global User Interaction"
    ],
    "answer": "Graphical User Interface"
  },
  {
    "question": "Which of the following is an example of a programming language?",
    "options": [
      "Access",
      "Java",
      "Excel",
      "PowerPoint"
    ],
    "answer": "Java"
  },
  {
    "question": "What is the function of a router?",
    "options": [
      "To store data",
      "To display data",
      "To route data between networks",
      "To type data"
    ],
    "answer": "To route data between networks"
  },
  {
    "question": "Which software is best for creating slideshows?",
    "options": [
      "Excel",
      "PowerPoint",
      "Access",
      "Word"
    ],
    "answer": "PowerPoint"
  },
  {
    "question": "In which part of the spreadsheet would you enter a formula?",
    "options": [
      "Sheet Tab",
      "Status Bar",
      "Formula Bar",
      "Title Bar"
    ],
    "answer": "Formula Bar"
  },
  {
    "question": "Which HTML tag defines the largest heading?",
    "options": [
      "<h6>",
      "<h1>",
      "<head>",
      "<h7>"
    ],
    "answer": "<h1>"
  },
  {
    "question": "What is a byte composed of?",
    "options": [
      "4 bits",
      "2 bits",
      "8 bits",
      "10 bits"
    ],
    "answer": "8 bits"
  },
  {
    "question": "Which of the following is an input device?",
    "options": [
      "Plotter",
      "Monitor",
      "Printer",
      "Keyboard"
    ],
    "answer": "Keyboard"
  },
  {
    "question": "Which tool in a database is used to customize the appearance of data?",
    "options": [
      "Query",
      "Form",
      "Table",
      "Macro"
    ],
    "answer": "Form"
  },
  {
    "question": "What does CSS stand for in web design?",
    "options": [
      "Creative Style Sheet",
      "Cascading Style Sheet",
      "Colorful Style Sheet",
      "Computer Style Sheet"
    ],
    "answer": "Cascading Style Sheet"
  },
  {
    "question": "What is a modem used for?",
    "options": [
      "Compress files",
      "Connect to the internet",
      "Store information",
      "Type documents"
    ],
    "answer": "Connect to the internet"
  },
  {
    "question": "Which program helps manage computer hardware?",
    "options": [
      "Word Processor",
      "Operating System",
      "Presentation Software",
      "Spreadsheet"
    ],
    "answer": "Operating System"
  },
  {
    "question": "What is the main role of an antivirus?",
    "options": [
      "Store files",
      "Play music",
      "Protect against malware",
      "Send emails"
    ],
    "answer": "Protect against malware"
  },
  {
    "question": "Which of these is a valid HTML tag for a paragraph?",
    "options": [
      "<pg>",
      "<para>",
      "<p>",
      "<pt>"
    ],
    "answer": "<p>"
  },
  {
    "question": "Which programming concept uses 'if', 'else' statements?",
    "options": [
      "Looping",
      "Branching",
      "Functions",
      "Classes"
    ],
    "answer": "Branching"
  },
  {
    "question": "Which storage medium is best for archiving large amounts of data?",
    "options": [
      "RAM",
      "DVD",
      "SSD",
      "Cloud Storage"
    ],
    "answer": "Cloud Storage"
  },
  {
    "question": "Which is an advantage of using a database?",
    "options": [
      "More graphics",
      "Data consistency",
      "Slow processing",
      "Difficult entry"
    ],
    "answer": "Data consistency"
  },
  {
    "question": "What is the shortcut for copying in most software?",
    "options": [
      "Ctrl + V",
      "Ctrl + C",
      "Ctrl + X",
      "Ctrl + A"
    ],
    "answer": "Ctrl + C"
  },
  {
    "question": "Which tag is used to create hyperlinks in HTML?",
    "options": [
      "<link>",
      "<url>",
      "<a>",
      "<href>"
    ],
    "answer": "<a>"
  },
  {
    "question": "What is the purpose of the <br> tag in HTML?",
    "options": [
      "Breaks line",
      "Creates bold text",
      "Adds a border",
      "Starts a paragraph"
    ],
    "answer": "Breaks line"
  },
  {
    "question": "What does 'debugging' refer to in programming?",
    "options": [
      "Writing code",
      "Removing errors",
      "Adding comments",
      "Saving the program"
    ],
    "answer": "Removing errors"
  },
  {
    "question": "Which of these is used to organize records in a database?",
    "options": [
      "Form",
      "Report",
      "Table",
      "Query"
    ],
    "answer": "Table"
  },
  {
    "question": "What is phishing?",
    "options": [
      "A hardware component",
      "A virus type",
      "A type of scam to steal information",
      "A printer function"
    ],
    "answer": "A type of scam to steal information"
  },
  {
    "question": "What symbol is used to begin a comment in many programming languages?",
    "options": [
      "#",
      "$",
      "@",
      "&"
    ],
    "answer": "#"
  },
  {
    "question": "Which component holds all other internal parts of the computer?",
    "options": [
      "Monitor",
      "Keyboard",
      "Motherboard",
      "Speaker"
    ],
    "answer": "Motherboard"
  },
  {
    "question": "Which software can help create and manage a budget?",
    "options": [
      "Database",
      "Spreadsheet",
      "Word Processor",
      "Web Browser"
    ],
    "answer": "Spreadsheet"
  },
  {
    "question": "Which HTML tag is used to create a numbered list?",
    "options": [
      "<ul>",
      "<ol>",
      "<li>",
      "<list>"
    ],
    "answer": "<ol>"
  },
  {
    "question": "Which of the following is a way to protect your personal data online?",
    "options": [
      "Sharing passwords",
      "Using public Wi-Fi",
      "Using strong passwords",
      "Ignoring software updates"
    ],
    "answer": "Using strong passwords"
  },
  {
    "question": "What is the function of RAM?",
    "options": [
      "Stores permanent data",
      "Executes programs",
      "Stores temporary data for quick access",
      "Monitors temperature"
    ],
    "answer": "Stores temporary data for quick access"
  },
  {
    "question": "Which program can be used to write HTML code?",
    "options": [
      "Paint",
      "Notepad",
      "Excel",
      "Access"
    ],
    "answer": "Notepad"
  },
  {
    "question": "Which of these is a type of loop in programming?",
    "options": [
      "for",
      "if",
      "next",
      "define"
    ],
    "answer": "for"
  },
  {
    "question": "Which device translates digital signals into analog?",
    "options": [
      "Router",
      "Modem",
      "Switch",
      "Hub"
    ],
    "answer": "Modem"
  },
  {
    "question": "What does a compiler do?",
    "options": [
      "Runs hardware tests",
      "Converts code to machine language",
      "Manages files",
      "Stores documents"
    ],
    "answer": "Converts code to machine language"
  },
  {
    "question": "Which of these is an example of cloud storage?",
    "options": [
      "Pen Drive",
      "Google Drive",
      "CD-ROM",
      "RAM"
    ],
    "answer": "Google Drive"
  },
  {
    "question": "Which element contains metadata in an HTML document?",
    "options": [
      "<meta>",
      "<head>",
      "<title>",
      "<body>"
    ],
    "answer": "<head>"
  },
  {
    "question": "Which component is used to cool the CPU?",
    "options": [
      "Heat sink",
      "Speaker",
      "Scanner",
      "Motherboard"
    ],
    "answer": "Heat sink"
  },
  {
    "question": "Which of the following is NOT an example of an output device?",
    "options": [
      "Monitor",
      "Printer",
      "Speaker",
      "Mouse"
    ],
    "answer": "Mouse"
  },
  {
    "question": "Which of the following is a feature of a good presentation?",
    "options": [
      "Cluttered slides",
      "Readable fonts",
      "Excessive text",
      "Low contrast"
    ],
    "answer": "Readable fonts"
  },
  {
    "question": "In HTML, what tag is used to insert a line break?",
    "options": [
      "<break>",
      "<line>",
      "<br>",
      "<lb>"
    ],
    "answer": "<br>"
  },
  {
    "question": "Which of the following is a characteristic of good programming?",
    "options": [
      "Uncommented code",
      "Clear logic",
      "Hardcoding values",
      "Complex naming"
    ],
    "answer": "Clear logic"
  },
  {
    "question": "Which file extension is used for Excel workbooks?",
    "options": [
      ".docx",
      ".xlsx",
      ".pptx",
      ".html"
    ],
    "answer": ".xlsx"
  },
  {
    "question": "What is a hyperlink?",
    "options": [
      "A storage device",
      "A network connector",
      "A clickable link",
      "A password type"
    ],
    "answer": "A clickable link"
  },
  {
    "question": "What does a UPS do?",
    "options": [
      "Saves files",
      "Cools CPU",
      "Provides backup power",
      "Increases speed"
    ],
    "answer": "Provides backup power"
  },
  {
    "question": "Which of these is an example of a top-level domain?",
    "options": [
      ".com",
      "http",
      "www",
      ".html"
    ],
    "answer": ".com"
  },
  {
    "question": "What does the <img> tag in HTML do?",
    "options": [
      "Displays an image",
      "Inserts a video",
      "Formats text",
      "Creates a table"
    ],
    "answer": "Displays an image"
  },
  {
    "question": "Which of the following is a utility software?",
    "options": [
      "MS Word",
      "Disk Cleanup",
      "PowerPoint",
      "Excel"
    ],
    "answer": "Disk Cleanup"
  },
  {
    "question": "What is the purpose of a spreadsheet application?",
    "options": [
      "Graphic design",
      "Data analysis and calculations",
      "Browsing the internet",
      "Video editing"
    ],
    "answer": "Data analysis and calculations"
  },
  {
    "question": "Which of these is a form of data communication?",
    "options": [
      "RAM",
      "Bluetooth",
      "Monitor",
      "USB"
    ],
    "answer": "Bluetooth"
  },
  {
    "question": "Which software would you use to create a database?",
    "options": [
      "MS Access",
      "MS Paint",
      "Notepad",
      "PowerPoint"
    ],
    "answer": "MS Access"
  },
  {
    "question": "In programming, what is a variable?",
    "options": [
      "A fixed number",
      "A type of comment",
      "A placeholder for data",
      "An operator"
    ],
    "answer": "A placeholder for data"
  },
  {
    "question": "What is the purpose of a search engine?",
    "options": [
      "To send emails",
      "To find information online",
      "To install software",
      "To create databases"
    ],
    "answer": "To find information online"
  },
  {
    "question": "Which HTML tag is used to define a table row?",
    "options": [
      "<tr>",
      "<td>",
      "<table>",
      "<th>"
    ],
    "answer": "<tr>"
  },
  {
    "question": "What type of software is Linux?",
    "options": [
      "Application software",
      "System software",
      "Utility software",
      "Presentation software"
    ],
    "answer": "System software"
  },
  {
    "question": "Which of these is an example of a high-level programming language?",
    "options": [
      "Assembly",
      "Python",
      "Binary",
      "Machine Code"
    ],
    "answer": "Python"
  },
  {
    "question": "What is malware?",
    "options": [
      "A network cable",
      "Software designed to harm a system",
      "A programming language",
      "A spreadsheet function"
    ],
    "answer": "Software designed to harm a system"
  },
  {
    "question": "What is the first step in the program development life cycle?",
    "options": [
      "Testing",
      "Coding",
      "Problem definition",
      "Documentation"
    ],
    "answer": "Problem definition"
  },
  {
    "question": "Which of the following is NOT a network topology?",
    "options": [
      "Bus",
      "Ring",
      "Star",
      "Square"
    ],
    "answer": "Square"
  },
  {
    "question": "What is the function of a form in a database?",
    "options": [
      "To perform calculations",
      "To enter and edit data",
      "To sort records",
      "To delete a table"
    ],
    "answer": "To enter and edit data"
  },
  {
    "question": "Which HTML tag is used to insert a hyperlink?",
    "options": [
      "<link>",
      "<href>",
      "<a>",
      "<hlink>"
    ],
    "answer": "<a>"
  },
  {
    "question": "Which key combination is used to paste copied content?",
    "options": [
      "Ctrl + X",
      "Ctrl + V",
      "Ctrl + C",
      "Ctrl + P"
    ],
    "answer": "Ctrl + V"
  },
  {
    "question": "Which component temporarily stores data for quick processing?",
    "options": [
      "Hard Drive",
      "RAM",
      "SSD",
      "CPU"
    ],
    "answer": "RAM"
  },
  {
    "question": "Which of the following is an example of an application software?",
    "options": [
      "MS Word",
      "Windows OS",
      "BIOS",
      "Device Driver"
    ],
    "answer": "MS Word"
  },
  {
    "question": "What does <b> tag do in HTML?",
    "options": [
      "Break line",
      "Bold text",
      "Insert table",
      "Italicize text"
    ],
    "answer": "Bold text"
  },
  {
    "question": "Which device allows input by touch?",
    "options": [
      "Scanner",
      "Touchscreen",
      "Monitor",
      "Speaker"
    ],
    "answer": "Touchscreen"
  },
  {
    "question": "What does the acronym CPU stand for?",
    "options": [
      "Central Programming Unit",
      "Central Process Utility",
      "Central Processing Unit",
      "Control Panel Utility"
    ],
    "answer": "Central Processing Unit"
  },
  {
    "question": "Which of the following file formats is for an image?",
    "options": [
      ".docx",
      ".xlsx",
      ".jpg",
      ".pptx"
    ],
    "answer": ".jpg"
  },
  {
    "question": "What is the use of <hr> in HTML?",
    "options": [
      "To highlight text",
      "To create a horizontal line",
      "To insert heading",
      "To hyperlink text"
    ],
    "answer": "To create a horizontal line"
  },
  {
    "question": "Which device is used to print on paper?",
    "options": [
      "Monitor",
      "Projector",
      "Printer",
      "Mouse"
    ],
    "answer": "Printer"
  },
  {
    "question": "What is the purpose of a switch in a network?",
    "options": [
      "Stores data",
      "Transfers electricity",
      "Connects multiple devices in a network",
      "Types data"
    ],
    "answer": "Connects multiple devices in a network"
  },
  {
    "question": "What is the full meaning of HTML?",
    "options": [
      "HighText Machine Language",
      "HyperText Markup Language",
      "HyperTabular Markup Language",
      "HyperText Markdown Language"
    ],
    "answer": "HyperText Markup Language"
  },
  {
    "question": "Which of the following is a common spreadsheet file extension?",
    "options": [
      ".txt",
      ".xlsx",
      ".pdf",
      ".html"
    ],
    "answer": ".xlsx"
  },
  {
    "question": "Which of the following is used to define a cell in a spreadsheet?",
    "options": [
      "Row",
      "Formula",
      "Address",
      "Function"
    ],
    "answer": "Address"
  },
  {
    "question": "What is the purpose of a report in a database?",
    "options": [
      "To delete data",
      "To display formatted data",
      "To input data",
      "To design forms"
    ],
    "answer": "To display formatted data"
  },
  {
    "question": "Which software would you use for programming?",
    "options": [
      "Photoshop",
      "Python",
      "CorelDraw",
      "Excel"
    ],
    "answer": "Python"
  },
  {
    "question": "What does a URL stand for?",
    "options": [
      "Uniform Resource Locator",
      "Universal Reference Link",
      "Universal Resource Link",
      "Uniform Remote Link"
    ],
    "answer": "Uniform Resource Locator"
  },
  {
    "question": "Which of these helps to diagnose and fix PC issues?",
    "options": [
      "Compiler",
      "Disk Defragmenter",
      "Debugger",
      "Web Browser"
    ],
    "answer": "Debugger"
  },
  {
    "question": "What symbol is used for an OR gate in logic diagrams?",
    "options": [
      "?",
      "?",
      "?",
      "~"
    ],
    "answer": "?"
  },
  {
    "question": "What is a flowchart?",
    "options": [
      "A chart to show employee flow",
      "A chart that shows program logic",
      "A networking diagram",
      "A graphical user interface"
    ],
    "answer": "A chart that shows program logic"
  },
  {
    "question": "Which tag defines a table cell in HTML?",
    "options": [
      "<tr>",
      "<td>",
      "<th>",
      "<tc>"
    ],
    "answer": "<td>"
  },
  {
    "question": "What is the best tool for analyzing sales data?",
    "options": [
      "Word Processor",
      "Presentation Software",
      "Spreadsheet",
      "Database"
    ],
    "answer": "Spreadsheet"
  },
  {
    "question": "Which programming language is mostly used for web scripting?",
    "options": [
      "C++",
      "Python",
      "JavaScript",
      "Pascal"
    ],
    "answer": "JavaScript"
  },
  {
    "question": "Which of these is used to secure a network?",
    "options": [
      "Firewall",
      "Switch",
      "Router",
      "Hub"
    ],
    "answer": "Firewall"
  },
  {
    "question": "Which of these is a secondary storage device?",
    "options": [
      "RAM",
      "ROM",
      "Hard Disk Drive",
      "Cache"
    ],
    "answer": "Hard Disk Drive"
  },
  {
    "question": "What is the name of the first page of a website?",
    "options": [
      "Menu",
      "Index",
      "Home page",
      "Title page"
    ],
    "answer": "Home page"
  },
  {
    "question": "Which command is used to cut selected text?",
    "options": [
      "Ctrl + X",
      "Ctrl + C",
      "Ctrl + V",
      "Ctrl + A"
    ],
    "answer": "Ctrl + X"
  },
  {
    "question": "Which input device uses a laser to scan barcodes?",
    "options": [
      "Scanner",
      "Touchpad",
      "Barcode Reader",
      "Webcam"
    ],
    "answer": "Barcode Reader"
  },
  {
    "question": "Which of the following is not a database object?",
    "options": [
      "Table",
      "Report",
      "Slide",
      "Query"
    ],
    "answer": "Slide"
  },
  {
    "question": "What is the binary equivalent of decimal number 5?",
    "options": [
      "101",
      "111",
      "100",
      "110"
    ],
    "answer": "101"
  },
  {
    "question": "Which software is used to draw logos?",
    "options": [
      "Excel",
      "CorelDraw",
      "Access",
      "Notepad"
    ],
    "answer": "CorelDraw"
  },
  {
    "question": "What is the result of 2^3 in most programming languages?",
    "options": [
      "6",
      "8",
      "9",
      "5"
    ],
    "answer": "8"
  },
  {
    "question": "Which of these is an ICT tool for education?",
    "options": [
      "Overhead projector",
      "Broom",
      "Television",
      "Notebook"
    ],
    "answer": "Overhead projector"
  },
  {
    "question": "What is the main function of the ALU in a CPU?",
    "options": [
      "Stores data",
      "Performs arithmetic and logical operations",
      "Displays output",
      "Reads programs"
    ],
    "answer": "Performs arithmetic and logical operations"
  },
  {
    "question": "Which of these is not a type of network topology?",
    "options": [
      "Star",
      "Mesh",
      "Linear",
      "Circular"
    ],
    "answer": "Circular"
  },
  {
    "question": "What is an algorithm?",
    "options": [
      "A programming language",
      "A hardware component",
      "A step-by-step procedure to solve a problem",
      "A software application"
    ],
    "answer": "A step-by-step procedure to solve a problem"
  },
  {
    "question": "Which device converts digital signals to analog?",
    "options": [
      "Router",
      "Switch",
      "Modem",
      "Firewall"
    ],
    "answer": "Modem"
  },
  {
    "question": "Which of these is a type of secondary storage?",
    "options": [
      "Cache",
      "RAM",
      "CD-ROM",
      "Register"
    ],
    "answer": "CD-ROM"
  },
  {
    "question": "What is the purpose of a compiler?",
    "options": [
      "To write documents",
      "To manage files",
      "To convert source code into machine code",
      "To browse the web"
    ],
    "answer": "To convert source code into machine code"
  },
  {
    "question": "Which of the following is an example of application software?",
    "options": [
      "BIOS",
      "Windows OS",
      "Microsoft Word",
      "Device Driver"
    ],
    "answer": "Microsoft Word"
  },
  {
    "question": "What does a router do in a network?",
    "options": [
      "Stores data",
      "Routes data between networks",
      "Manages databases",
      "Secures software"
    ],
    "answer": "Routes data between networks"
  },
  {
    "question": "Which of these tags creates a line break in HTML?",
    "options": [
      "<br>",
      "<line>",
      "<hr>",
      "<lb>"
    ],
    "answer": "<br>"
  },
  {
    "question": "Which of the following is NOT an operating system?",
    "options": [
      "Windows",
      "Linux",
      "Android",
      "Excel"
    ],
    "answer": "Excel"
  },
  {
    "question": "What is data security?",
    "options": [
      "Hiding data",
      "Making backups of data",
      "Protecting data from unauthorized access",
      "Deleting old data"
    ],
    "answer": "Protecting data from unauthorized access"
  },
  {
    "question": "What is the purpose of the Print Preview function?",
    "options": [
      "To save a file",
      "To view a document before printing",
      "To scan a document",
      "To edit headers"
    ],
    "answer": "To view a document before printing"
  },
  {
    "question": "What does the term 'booting' refer to?",
    "options": [
      "Installing software",
      "Shutting down the computer",
      "Starting the computer",
      "Accessing the internet"
    ],
    "answer": "Starting the computer"
  },
  {
    "question": "Which of the following uses optical storage?",
    "options": [
      "Flash drive",
      "DVD",
      "Hard disk",
      "SSD"
    ],
    "answer": "DVD"
  },
  {
    "question": "Which spreadsheet function adds a range of numbers?",
    "options": [
      "=TOTAL()",
      "=ADD()",
      "=SUM()",
      "=PLUS()"
    ],
    "answer": "=SUM()"
  },
  {
    "question": "Which of these is used to reduce file size?",
    "options": [
      "Compression software",
      "Antivirus",
      "Compiler",
      "Debugger"
    ],
    "answer": "Compression software"
  },
  {
    "question": "What is phishing?",
    "options": [
      "Fishing with a computer",
      "Fake websites or emails used to steal information",
      "Installing viruses",
      "Downloading software"
    ],
    "answer": "Fake websites or emails used to steal information"
  },
  {
    "question": "Which of the following is an input device?",
    "options": [
      "Printer",
      "Monitor",
      "Keyboard",
      "Speaker"
    ],
    "answer": "Keyboard"
  },
  {
    "question": "What is HTML used for?",
    "options": [
      "Creating animations",
      "Designing documents",
      "Structuring web pages",
      "Writing reports"
    ],
    "answer": "Structuring web pages"
  },
  {
    "question": "What does RAM stand for?",
    "options": [
      "Random Access Memory",
      "Read Access Module",
      "Rapid Application Management",
      "Random Application Memory"
    ],
    "answer": "Random Access Memory"
  },
  {
    "question": "Which of the following helps protect a computer from malware?",
    "options": [
      "Firewall",
      "Switch",
      "Router",
      "Printer"
    ],
    "answer": "Firewall"
  },
  {
    "question": "Which key is used to delete text to the left of the cursor?",
    "options": [
      "Delete",
      "Escape",
      "Backspace",
      "Tab"
    ],
    "answer": "Backspace"
  },
  {
    "question": "Which of these is a type of chart in spreadsheets?",
    "options": [
      "Picture chart",
      "Bar chart",
      "Letter chart",
      "Structure chart"
    ],
    "answer": "Bar chart"
  },
  {
    "question": "What type of software is used to create presentations?",
    "options": [
      "Word processor",
      "Spreadsheet",
      "Presentation software",
      "Database software"
    ],
    "answer": "Presentation software"
  },
  {
    "question": "Which device is required to connect to the internet?",
    "options": [
      "Scanner",
      "Modem",
      "Printer",
      "Speaker"
    ],
    "answer": "Modem"
  },
  {
    "question": "Which of these is not a form of output?",
    "options": [
      "Monitor",
      "Speaker",
      "Printer",
      "Mouse"
    ],
    "answer": "Mouse"
  },
  {
    "question": "Which tool is best for drawing diagrams?",
    "options": [
      "Spreadsheet",
      "Paint",
      "Word processor",
      "Access"
    ],
    "answer": "Paint"
  },
  {
    "question": "What is the default file extension for Word documents?",
    "options": [
      ".xls",
      ".docx",
      ".pptx",
      ".pdf"
    ],
    "answer": ".docx"
  },
  {
    "question": "What does WYSIWYG stand for in DTP?",
    "options": [
      "What You See Is What You Get",
      "When You Start I Will Go",
      "What You Say Is What You Get",
      "Work Your System In Web Gateway"
    ],
    "answer": "What You See Is What You Get"
  },
  {
    "question": "What does the IF function do in Excel?",
    "options": [
      "Adds numbers",
      "Checks a condition and returns a value",
      "Formats cells",
      "Creates charts"
    ],
    "answer": "Checks a condition and returns a value"
  },
  {
    "question": "Which of the following helps create structured documents?",
    "options": [
      "HTML",
      "PDF",
      "Excel",
      "JPEG"
    ],
    "answer": "HTML"
  },
  {
    "question": "What device is needed to project presentations to an audience?",
    "options": [
      "Monitor",
      "Projector",
      "Scanner",
      "Touchpad"
    ],
    "answer": "Projector"
  },
  {
    "question": "Which of the following is NOT a database object?",
    "options": [
      "Form",
      "Slide",
      "Table",
      "Query"
    ],
    "answer": "Slide"
  },
  {
    "question": "What programming concept involves repeating a set of instructions?",
    "options": [
      "Condition",
      "Loop",
      "Branch",
      "Variable"
    ],
    "answer": "Loop"
  },
  {
    "question": "What is a hyperlink?",
    "options": [
      "Text that prints a page",
      "Text that connects to another document or location",
      "An internet connection",
      "A network topology"
    ],
    "answer": "Text that connects to another document or location"
  },
  {
    "question": "Which is a feature of multimedia in education?",
    "options": [
      "Static pages",
      "Text only",
      "Combination of text, images, and sound",
      "Printed materials only"
    ],
    "answer": "Combination of text, images, and sound"
  },
  {
    "question": "Which file type is most likely to contain a virus?",
    "options": [
      ".exe",
      ".txt",
      ".jpg",
      ".pdf"
    ],
    "answer": ".exe"
  },
  {
    "question": "Which of the following is a programming language?",
    "options": [
      "Oracle",
      "Python",
      "MySQL",
      "Access"
    ],
    "answer": "Python"
  },
  {
    "question": "Which symbol is used for comments in HTML?",
    "options": [
      "//",
      "#",
      "<!-- -->",
      "/* */"
    ],
    "answer": "<!-- -->"
  },
  {
    "question": "What is meant by �debugging� a program?",
    "options": [
      "Adding more code",
      "Making the program faster",
      "Removing errors",
      "Installing the program"
    ],
    "answer": "Removing errors"
  },
  {
    "question": "Which HTML tag is used for creating a hyperlink?",
    "options": [
      "<link>",
      "<a>",
      "<href>",
      "<hyper>"
    ],
    "answer": "<a>"
  },
  {
    "question": "Which of these is NOT a digital storage media?",
    "options": [
      "CD-ROM",
      "Hard Disk",
      "Flash Drive",
      "Floppy Disk"
    ],
    "answer": "Floppy Disk"
  },
  {
    "question": "What is the role of the control unit in the CPU?",
    "options": [
      "Stores data",
      "Executes calculations",
      "Directs operations",
      "Displays information"
    ],
    "answer": "Directs operations"
  },
  {
    "question": "Which of these is an example of a markup language?",
    "options": [
      "Java",
      "HTML",
      "Python",
      "C++"
    ],
    "answer": "HTML"
  },
  {
    "question": "Which of the following is an example of a database management system?",
    "options": [
      "Excel",
      "Access",
      "Photoshop",
      "PowerPoint"
    ],
    "answer": "Access"
  },
  {
    "question": "What is the primary function of a query in a database?",
    "options": [
      "To print data",
      "To retrieve specific data",
      "To delete the database",
      "To format cells"
    ],
    "answer": "To retrieve specific data"
  },
  {
    "question": "Which of the following is NOT a secondary storage device?",
    "options": [
      "CD-ROM",
      "Hard disk",
      "RAM",
      "USB flash drive"
    ],
    "answer": "RAM"
  },
  {
    "question": "What does the term GUI stand for?",
    "options": [
      "Graphical User Interface",
      "General Utility Interface",
      "Graphical Uniform Interaction",
      "Global User Interaction"
    ],
    "answer": "Graphical User Interface"
  },
  {
    "question": "Which HTML tag is used to create a table row?",
    "options": [
      "<td>",
      "<th>",
      "<tr>",
      "<table>"
    ],
    "answer": "<tr>"
  },
  {
    "question": "Which of these is an advantage of e-learning?",
    "options": [
      "Increased textbook cost",
      "Fixed learning pace",
      "Accessibility from anywhere",
      "Requires printed materials"
    ],
    "answer": "Accessibility from anywhere"
  },
  {
    "question": "What is the default orientation of a worksheet in Excel?",
    "options": [
      "Landscape",
      "Portrait",
      "Diagonal",
      "Vertical"
    ],
    "answer": "Portrait"
  },
  {
    "question": "Which of these is an example of an input device?",
    "options": [
      "Speaker",
      "Monitor",
      "Mouse",
      "Projector"
    ],
    "answer": "Mouse"
  },
  {
    "question": "Which network device connects multiple computers within a LAN?",
    "options": [
      "Modem",
      "Switch",
      "Repeater",
      "Firewall"
    ],
    "answer": "Switch"
  },
  {
    "question": "Which of these software types helps you create a publication layout?",
    "options": [
      "Spreadsheet",
      "Database",
      "DTP",
      "Browser"
    ],
    "answer": "DTP"
  },
  {
    "question": "What is the purpose of the �Save As� function?",
    "options": [
      "To delete a file",
      "To rename or duplicate a file",
      "To open a file",
      "To print a document"
    ],
    "answer": "To rename or duplicate a file"
  },
  {
    "question": "What does a URL represent?",
    "options": [
      "Universal Remote Location",
      "Unified Resource Locator",
      "Uniform Resource Locator",
      "Unified Reference Link"
    ],
    "answer": "Uniform Resource Locator"
  },
  {
    "question": "Which of the following is NOT a programming language?",
    "options": [
      "Python",
      "C++",
      "Photoshop",
      "Java"
    ],
    "answer": "Photoshop"
  },
  {
    "question": "Which of these stores data temporarily?",
    "options": [
      "ROM",
      "Flash Drive",
      "Hard Drive",
      "RAM"
    ],
    "answer": "RAM"
  },
  {
    "question": "What is a flowchart used for?",
    "options": [
      "Writing code",
      "Representing program logic graphically",
      "Drawing shapes",
      "Designing websites"
    ],
    "answer": "Representing program logic graphically"
  },
  {
    "question": "Which of the following tools is used to test software?",
    "options": [
      "Debugger",
      "Text editor",
      "Word processor",
      "Compiler"
    ],
    "answer": "Debugger"
  },
  {
    "question": "Which media is best for high-speed, short-distance communication?",
    "options": [
      "Twisted pair cable",
      "Fiber optic",
      "Satellite",
      "Wi-Fi"
    ],
    "answer": "Fiber optic"
  },
  {
    "question": "Which tag is used to insert images in HTML?",
    "options": [
      "<image>",
      "<src>",
      "<img>",
      "<pic>"
    ],
    "answer": "<img>"
  },
  {
    "question": "In databases, what is a report used for?",
    "options": [
      "To input data",
      "To filter data",
      "To display formatted output",
      "To delete data"
    ],
    "answer": "To display formatted output"
  },
  {
    "question": "What is the file extension for an HTML document?",
    "options": [
      ".htm",
      ".docx",
      ".exe",
      ".xlsx"
    ],
    "answer": ".htm"
  },
  {
    "question": "What is the major purpose of antivirus software?",
    "options": [
      "To design websites",
      "To remove malware",
      "To browse the web",
      "To store passwords"
    ],
    "answer": "To remove malware"
  },
  {
    "question": "Which function in Excel calculates the average of values?",
    "options": [
      "=ADD()",
      "=MEAN()",
      "=AVG()",
      "=AVERAGE()"
    ],
    "answer": "=AVERAGE()"
  },
  {
    "question": "Which of these is NOT found in a DTP application?",
    "options": [
      "Text box",
      "Slide transition",
      "Image frame",
      "Layout guides"
    ],
    "answer": "Slide transition"
  },
  {
    "question": "What is the full meaning of ISP?",
    "options": [
      "Internet Service Provider",
      "Internal Service Protocol",
      "Information Sharing Program",
      "International Software Provider"
    ],
    "answer": "Internet Service Provider"
  },
  {
    "question": "Which HTML tag is used to create a list item?",
    "options": [
      "<ul>",
      "<ol>",
      "<li>",
      "<list>"
    ],
    "answer": "<li>"
  },
  {
    "question": "What is the first phase in the Program Development Life Cycle?",
    "options": [
      "Testing",
      "Problem definition",
      "Coding",
      "Maintenance"
    ],
    "answer": "Problem definition"
  },
  {
    "question": "What does a formula in Excel always begin with?",
    "options": [
      "+",
      "=",
      "-",
      "/"
    ],
    "answer": "="
  },
  {
    "question": "Which component holds the BIOS in a computer?",
    "options": [
      "RAM",
      "ROM",
      "CPU",
      "Hard drive"
    ],
    "answer": "ROM"
  },
  {
    "question": "What does the 'print' command do in programming?",
    "options": [
      "Deletes output",
      "Displays output on screen",
      "Starts the program",
      "Stops the program"
    ],
    "answer": "Displays output on screen"
  },
  {
    "question": "Which application is best for calculating and analyzing data?",
    "options": [
      "Word processor",
      "Spreadsheet",
      "DTP",
      "Database"
    ],
    "answer": "Spreadsheet"
  },
  {
    "question": "Which feature allows data entry in a form layout in databases?",
    "options": [
      "Query",
      "Table",
      "Form",
      "Report"
    ],
    "answer": "Form"
  },
  {
    "question": "Which device displays hardcopy output?",
    "options": [
      "Monitor",
      "Speaker",
      "Projector",
      "Printer"
    ],
    "answer": "Printer"
  },
  {
    "question": "What is the primary use of spreadsheet software?",
    "options": [
      "Photo editing",
      "Data organization and calculation",
      "Database management",
      "Slide presentation"
    ],
    "answer": "Data organization and calculation"
  },
  {
    "question": "What symbol is used for comments in Python?",
    "options": [
      "#",
      "//",
      "/* */",
      "--"
    ],
    "answer": "#"
  },
  {
    "question": "What is a hyperlink primarily used for?",
    "options": [
      "To change font",
      "To print",
      "To connect to other web resources",
      "To scroll pages"
    ],
    "answer": "To connect to other web resources"
  },
  {
    "question": "Which of the following uses the .pptx extension?",
    "options": [
      "Word document",
      "Presentation file",
      "Spreadsheet",
      "Webpage"
    ],
    "answer": "Presentation file"
  },
  {
    "question": "Which of these is a feature of a good password?",
    "options": [
      "Only letters",
      "Only numbers",
      "Short and easy",
      "Combination of letters, numbers, and symbols"
    ],
    "answer": "Combination of letters, numbers, and symbols"
  },
  {
    "question": "Which of these software types is used for photo editing?",
    "options": [
      "Photoshop",
      "Excel",
      "Access",
      "Notepad"
    ],
    "answer": "Photoshop"
  },
  {
    "question": "What does the 'SUM' function in Excel do?",
    "options": [
      "Multiplies values",
      "Counts values",
      "Adds values",
      "Sorts data"
    ],
    "answer": "Adds values"
  },
  {
    "question": "Which network device helps filter traffic based on rules?",
    "options": [
      "Switch",
      "Hub",
      "Firewall",
      "Repeater"
    ],
    "answer": "Firewall"
  },
  {
    "question": "Which of these is NOT a use of ICT in everyday life?",
    "options": [
      "Communication",
      "Learning",
      "Cooking food",
      "Banking"
    ],
    "answer": "Cooking food"
  },
  {
    "question": "What is the default alignment of text in Excel cells?",
    "options": [
      "Centered",
      "Left",
      "Justified",
      "Right"
    ],
    "answer": "Left"
  },
  {
    "question": "What is a tag in HTML?",
    "options": [
      "A software",
      "A file format",
      "An instruction for formatting content",
      "A hyperlink"
    ],
    "answer": "An instruction for formatting content"
  },
  {
    "question": "Which of the following is a type of software license?",
    "options": [
      "Open source",
      "Read-only",
      "Text-based",
      "Executable"
    ],
    "answer": "Open source"
  },
  {
    "question": "Which device is used for capturing still images?",
    "options": [
      "Monitor",
      "Speaker",
      "Digital camera",
      "Plotter"
    ],
    "answer": "Digital camera"
  },
  {
    "question": "What is a field in a database?",
    "options": [
      "A complete table",
      "A single record",
      "A column that holds one type of data",
      "An entire database"
    ],
    "answer": "A column that holds one type of data"
  },
  {
    "question": "What is the function of an operating system?",
    "options": [
      "Browsing the internet",
      "Managing hardware and software resources",
      "Creating spreadsheets",
      "Designing graphics"
    ],
    "answer": "Managing hardware and software resources"
  },
  {
    "question": "Which of the following is used to protect data in transit over a network?",
    "options": [
      "Firewall",
      "Encryption",
      "Router",
      "Modem"
    ],
    "answer": "Encryption"
  },
  {
    "question": "Which programming construct is used to repeat a block of code?",
    "options": [
      "If statement",
      "Loop",
      "Switch",
      "Case"
    ],
    "answer": "Loop"
  },
  {
    "question": "What is a hyperlink in a webpage?",
    "options": [
      "A connection to a printer",
      "A link to another location or webpage",
      "An image with a caption",
      "An animated icon"
    ],
    "answer": "A link to another location or webpage"
  },
  {
    "question": "Which of the following is NOT a network topology?",
    "options": [
      "Star",
      "Bus",
      "Ring",
      "Binary"
    ],
    "answer": "Binary"
  },
  {
    "question": "In spreadsheets, what does the fill handle do?",
    "options": [
      "Deletes content",
      "Copies content or formulas",
      "Prints worksheet",
      "Protects cells"
    ],
    "answer": "Copies content or formulas"
  },
  {
    "question": "Which of these is used to represent text in binary?",
    "options": [
      "ASCII",
      "JPEG",
      "HTML",
      "DNS"
    ],
    "answer": "ASCII"
  },
  {
    "question": "What is a macro in spreadsheet software?",
    "options": [
      "A large data value",
      "A shortcut to run repetitive tasks",
      "A formatting tool",
      "A security alert"
    ],
    "answer": "A shortcut to run repetitive tasks"
  },
  {
    "question": "What does DNS stand for in networking?",
    "options": [
      "Domain Name System",
      "Digital Network Service",
      "Data Name Server",
      "Domain Network Server"
    ],
    "answer": "Domain Name System"
  },
  {
    "question": "Which of these HTML tags is used to define a heading?",
    "options": [
      "<h1>",
      "<hd>",
      "<head>",
      "<title>"
    ],
    "answer": "<h1>"
  },
  {
    "question": "Which component is known as the brain of the computer?",
    "options": [
      "RAM",
      "Hard Drive",
      "CPU",
      "Monitor"
    ],
    "answer": "CPU"
  },
  {
    "question": "Which part of a computer is responsible for permanent storage?",
    "options": [
      "ROM",
      "RAM",
      "CPU",
      "Cache"
    ],
    "answer": "ROM"
  },
  {
    "question": "Which of these devices is used to digitize printed documents?",
    "options": [
      "Printer",
      "Monitor",
      "Scanner",
      "Mouse"
    ],
    "answer": "Scanner"
  },
  {
    "question": "Which of these is NOT a function of spreadsheet software?",
    "options": [
      "Sorting data",
      "Creating formulas",
      "Designing publications",
      "Charting data"
    ],
    "answer": "Designing publications"
  },
  {
    "question": "Which of the following allows two devices to communicate wirelessly?",
    "options": [
      "Bluetooth",
      "Ethernet cable",
      "USB port",
      "VGA cable"
    ],
    "answer": "Bluetooth"
  },
  {
    "question": "What is an algorithm?",
    "options": [
      "A programming language",
      "A software tool",
      "A step-by-step procedure for solving a problem",
      "A hardware device"
    ],
    "answer": "A step-by-step procedure for solving a problem"
  },
  {
    "question": "Which of these is a storage device?",
    "options": [
      "CPU",
      "RAM",
      "SSD",
      "Router"
    ],
    "answer": "SSD"
  },
  {
    "question": "Which software is best used for creating a newsletter?",
    "options": [
      "Spreadsheet",
      "Database",
      "Word processor",
      "Desktop Publishing"
    ],
    "answer": "Desktop Publishing"
  },
  {
    "question": "Which feature in DTP lets you align text in columns?",
    "options": [
      "Text box",
      "Grid layout",
      "Page number",
      "Layering"
    ],
    "answer": "Grid layout"
  },
  {
    "question": "Which of the following programming languages is widely used for web development?",
    "options": [
      "Python",
      "C",
      "JavaScript",
      "Pascal"
    ],
    "answer": "JavaScript"
  },
  {
    "question": "Which of the following is considered application software?",
    "options": [
      "Windows",
      "Linux",
      "Microsoft Word",
      "BIOS"
    ],
    "answer": "Microsoft Word"
  },
  {
    "question": "In HTML, what is used to define a hyperlink?",
    "options": [
      "<link>",
      "<href>",
      "<a>",
      "<url>"
    ],
    "answer": "<a>"
  },
  {
    "question": "Which of these is a principle of good publication design?",
    "options": [
      "Cluttered text",
      "Balance and alignment",
      "Using random fonts",
      "No white space"
    ],
    "answer": "Balance and alignment"
  },
  {
    "question": "What does IP address stand for?",
    "options": [
      "Internet Provider Address",
      "Internal Protocol Address",
      "Internet Protocol Address",
      "International Provider"
    ],
    "answer": "Internet Protocol Address"
  },
  {
    "question": "What is the role of a router?",
    "options": [
      "Displays information",
      "Stores information",
      "Connects networks",
      "Prints documents"
    ],
    "answer": "Connects networks"
  },
  {
    "question": "What is data validation in a spreadsheet?",
    "options": [
      "Changing cell color",
      "Restricting the type of data entered",
      "Formatting text",
      "Inserting images"
    ],
    "answer": "Restricting the type of data entered"
  },
  {
    "question": "Which of the following is a file extension for spreadsheets?",
    "options": [
      ".docx",
      ".xlsx",
      ".pptx",
      ".html"
    ],
    "answer": ".xlsx"
  },
  {
    "question": "What type of device is a modem?",
    "options": [
      "Input device",
      "Storage device",
      "Communication device",
      "Output device"
    ],
    "answer": "Communication device"
  },
  {
    "question": "What is used to uniquely identify each record in a database table?",
    "options": [
      "Foreign key",
      "Column",
      "Primary key",
      "Query"
    ],
    "answer": "Primary key"
  },
  {
    "question": "Which of the following is NOT a part of the CPU?",
    "options": [
      "ALU",
      "Control unit",
      "RAM",
      "Registers"
    ],
    "answer": "RAM"
  },
  {
    "question": "Which spreadsheet feature helps in analyzing trends?",
    "options": [
      "Charts",
      "Headers",
      "Gridlines",
      "Auto-fill"
    ],
    "answer": "Charts"
  },
  {
    "question": "Which of these helps control access to network resources?",
    "options": [
      "Firewall",
      "Switch",
      "Repeater",
      "Modem"
    ],
    "answer": "Firewall"
  },
  {
    "question": "What is phishing?",
    "options": [
      "Fishing with a computer",
      "A type of malware",
      "A social engineering attack to steal information",
      "A file compression method"
    ],
    "answer": "A social engineering attack to steal information"
  },
  {
    "question": "Which HTML tag displays an image?",
    "options": [
      "<pic>",
      "<src>",
      "<img>",
      "<link>"
    ],
    "answer": "<img>"
  },
  {
    "question": "Which device provides output in the form of sound?",
    "options": [
      "Monitor",
      "Speaker",
      "Mouse",
      "Scanner"
    ],
    "answer": "Speaker"
  },
  {
    "question": "What is malware?",
    "options": [
      "Hardware issue",
      "Data format",
      "Malicious software",
      "Network type"
    ],
    "answer": "Malicious software"
  },
  {
    "question": "Which of the following is a communication protocol?",
    "options": [
      "USB",
      "HTTP",
      "Excel",
      "HTML"
    ],
    "answer": "HTTP"
  },
  {
    "question": "What is the use of the IF function in Excel?",
    "options": [
      "Perform a sum",
      "Return different results based on a condition",
      "Sort data",
      "Insert images"
    ],
    "answer": "Return different results based on a condition"
  },
  {
    "question": "Which device connects to the internet using telephone lines?",
    "options": [
      "Router",
      "Switch",
      "Modem",
      "Repeater"
    ],
    "answer": "Modem"
  },
  {
    "question": "What does a database form allow you to do?",
    "options": [
      "Edit records easily",
      "Create charts",
      "Design tables",
      "Print webpages"
    ],
    "answer": "Edit records easily"
  },
  {
    "question": "Which feature in DTP helps create uniform spacing?",
    "options": [
      "Guides",
      "Bullets",
      "Text wrap",
      "Zoom"
    ],
    "answer": "Guides"
  },
  {
    "question": "Which part of the computer temporarily holds data and programs?",
    "options": [
      "ROM",
      "SSD",
      "RAM",
      "Cache"
    ],
    "answer": "RAM"
  },
  {
    "question": "What is a cookie in computing?",
    "options": [
      "A chocolate chip snack",
      "A temporary data file stored by a website",
      "A user profile",
      "A virus"
    ],
    "answer": "A temporary data file stored by a website"
  },
  {
    "question": "Which of these is an example of utility software?",
    "options": [
      "Antivirus",
      "PowerPoint",
      "Access",
      "Photoshop"
    ],
    "answer": "Antivirus"
  },
  {
    "question": "Which software is used to organize and manipulate large datasets?",
    "options": [
      "Word processor",
      "Spreadsheet",
      "Web browser",
      "Media player"
    ],
    "answer": "Spreadsheet"
  },
  {
    "question": "Which key on the keyboard is used to create a new line in a text document?",
    "options": [
      "Spacebar",
      "Shift",
      "Enter",
      "Ctrl"
    ],
    "answer": "Enter"
  },
  {
    "question": "What does the acronym ICT stand for?",
    "options": [
      "Information and Communication Technology",
      "International Computer Technology",
      "Internet and Computer Training",
      "Integrated Communication Technique"
    ],
    "answer": "Information and Communication Technology"
  },
  {
    "question": "Which of these is a primary storage device?",
    "options": [
      "Hard disk",
      "CD-ROM",
      "RAM",
      "Flash drive"
    ],
    "answer": "RAM"
  },
  {
    "question": "Which of the following is used to uniquely identify a website?",
    "options": [
      "HTML",
      "URL",
      "IP address",
      "Hyperlink"
    ],
    "answer": "URL"
  },
  {
    "question": "In programming, what does a 'loop' do?",
    "options": [
      "Ends the program",
      "Starts a new file",
      "Repeats a block of code",
      "Deletes variables"
    ],
    "answer": "Repeats a block of code"
  },
  {
    "question": "Which of the following is NOT a programming language?",
    "options": [
      "Python",
      "Java",
      "Excel",
      "C++"
    ],
    "answer": "Excel"
  },
  {
    "question": "What is the main purpose of using charts in a spreadsheet?",
    "options": [
      "To write long essays",
      "To display visual representation of data",
      "To format text",
      "To delete files"
    ],
    "answer": "To display visual representation of data"
  },
  {
    "question": "What type of storage is a CD-ROM?",
    "options": [
      "Primary storage",
      "Input device",
      "Secondary storage",
      "Processing device"
    ],
    "answer": "Secondary storage"
  },
  {
    "question": "Which of these is an example of a multimedia element?",
    "options": [
      "Plain text",
      "Table",
      "Audio",
      "Hyperlink"
    ],
    "answer": "Audio"
  },
  {
    "question": "Which type of network spans a large geographical area?",
    "options": [
      "LAN",
      "MAN",
      "PAN",
      "WAN"
    ],
    "answer": "WAN"
  },
  {
    "question": "What is the purpose of a form in a database?",
    "options": [
      "To print reports",
      "To add and view data easily",
      "To delete the database",
      "To backup files"
    ],
    "answer": "To add and view data easily"
  },
  {
    "question": "Which of these is an input device?",
    "options": [
      "Monitor",
      "Mouse",
      "Speaker",
      "Projector"
    ],
    "answer": "Mouse"
  },
  {
    "question": "Which of the following is used to identify an HTML document?",
    "options": [
      "<html>",
      "<page>",
      "<body>",
      "<tag>"
    ],
    "answer": "<html>"
  },
  {
    "question": "Which language is used to style HTML content?",
    "options": [
      "Java",
      "CSS",
      "Python",
      "C++"
    ],
    "answer": "CSS"
  },
  {
    "question": "Which device converts digital signals to analog and vice versa?",
    "options": [
      "Router",
      "Repeater",
      "Modem",
      "Switch"
    ],
    "answer": "Modem"
  },
  {
    "question": "Which component temporarily stores instructions and data for quick access?",
    "options": [
      "RAM",
      "Hard drive",
      "CPU",
      "ROM"
    ],
    "answer": "RAM"
  },
  {
    "question": "What is an advantage of using a database over a spreadsheet?",
    "options": [
      "Handles multimedia better",
      "Easier to write documents",
      "Better for complex data relationships",
      "Supports more colors"
    ],
    "answer": "Better for complex data relationships"
  },
  {
    "question": "Which of these is a correct HTML tag for a paragraph?",
    "options": [
      "<para>",
      "<p>",
      "<paragraph>",
      "<pg>"
    ],
    "answer": "<p>"
  },
  {
    "question": "Which tool is best for maintaining large records in education?",
    "options": [
      "Word processor",
      "Spreadsheet",
      "Database",
      "Graphics software"
    ],
    "answer": "Database"
  },
  {
    "question": "What does GUI stand for?",
    "options": [
      "General User Integration",
      "Graphical User Interface",
      "Graphic Upload Interface",
      "Gadget User Interface"
    ],
    "answer": "Graphical User Interface"
  },
  {
    "question": "Which of these is NOT a benefit of using ICT in education?",
    "options": [
      "Increases access to resources",
      "Improves collaboration",
      "Limits creativity",
      "Encourages active learning"
    ],
    "answer": "Limits creativity"
  },
  {
    "question": "In DTP, which tool is used to move elements freely?",
    "options": [
      "Pointer tool",
      "Zoom tool",
      "Crop tool",
      "Text tool"
    ],
    "answer": "Pointer tool"
  },
  {
    "question": "What is an HTML element used for inserting a break line?",
    "options": [
      "<break>",
      "<br>",
      "<bline>",
      "<lb>"
    ],
    "answer": "<br>"
  },
  {
    "question": "Which spreadsheet function finds the average of numbers?",
    "options": [
      "=SUM()",
      "=COUNT()",
      "=AVERAGE()",
      "=MIN()"
    ],
    "answer": "=AVERAGE()"
  },
  {
    "question": "Which storage device uses magnetic disks to store data?",
    "options": [
      "SSD",
      "Flash drive",
      "RAM",
      "Hard disk"
    ],
    "answer": "Hard disk"
  },
  {
    "question": "What is the main feature of a star network topology?",
    "options": [
      "All devices are connected in a ring",
      "All devices connect to a central hub",
      "Devices communicate directly",
      "There�s no central device"
    ],
    "answer": "All devices connect to a central hub"
  },
  {
    "question": "Which of these is a utility software?",
    "options": [
      "Notepad",
      "Excel",
      "Disk Cleanup",
      "Photoshop"
    ],
    "answer": "Disk Cleanup"
  },
  {
    "question": "What is software piracy?",
    "options": [
      "Making software backups",
      "Stealing hardware",
      "Using unlicensed software",
      "Installing drivers"
    ],
    "answer": "Using unlicensed software"
  },
  {
    "question": "Which programming construct allows decision making?",
    "options": [
      "Loop",
      "Function",
      "Array",
      "If statement"
    ],
    "answer": "If statement"
  },
  {
    "question": "Which of these is a form of secondary storage?",
    "options": [
      "Cache",
      "CD-ROM",
      "Register",
      "RAM"
    ],
    "answer": "CD-ROM"
  },
  {
    "question": "Which port is commonly used for connecting printers?",
    "options": [
      "USB",
      "HDMI",
      "VGA",
      "Ethernet"
    ],
    "answer": "USB"
  },
  {
    "question": "What is formatting in word processing?",
    "options": [
      "Changing the hard disk",
      "Changing appearance of text",
      "Printing the document",
      "Creating formulas"
    ],
    "answer": "Changing appearance of text"
  },
  {
    "question": "Which tag is used to insert an image in HTML?",
    "options": [
      "<pic>",
      "<image>",
      "<img>",
      "<src>"
    ],
    "answer": "<img>"
  },
  {
    "question": "Which of these is a feature of DTP software?",
    "options": [
      "Cell referencing",
      "Mail merge",
      "Layering",
      "Audio editing"
    ],
    "answer": "Layering"
  },
  {
    "question": "Which storage medium is reusable and portable?",
    "options": [
      "CD-ROM",
      "RAM",
      "Flash Drive",
      "Cache"
    ],
    "answer": "Flash Drive"
  },
  {
    "question": "What does LAN stand for?",
    "options": [
      "Local Access Node",
      "Large Area Network",
      "Local Area Network",
      "Linked Access Network"
    ],
    "answer": "Local Area Network"
  },
  {
    "question": "Which of these is NOT part of a programming life cycle?",
    "options": [
      "Problem identification",
      "Coding",
      "Execution",
      "Scanning"
    ],
    "answer": "Scanning"
  },
  {
    "question": "What is a function of an email client?",
    "options": [
      "Store movies",
      "Send and receive emails",
      "Browse websites",
      "Edit images"
    ],
    "answer": "Send and receive emails"
  },
  {
    "question": "Which spreadsheet tool allows for conditional checks?",
    "options": [
      "IF function",
      "Chart wizard",
      "Format painter",
      "Filter"
    ],
    "answer": "IF function"
  },
  {
    "question": "What is the output of a flowchart?",
    "options": [
      "Email",
      "Design",
      "Graphical logic of a program",
      "Text document"
    ],
    "answer": "Graphical logic of a program"
  },
  {
    "question": "Which device is used for soft copy output?",
    "options": [
      "Monitor",
      "Printer",
      "Scanner",
      "Keyboard"
    ],
    "answer": "Monitor"
  },
  {
    "question": "What is a key feature of spreadsheet software?",
    "options": [
      "Tables and animations",
      "Cells organized in rows and columns",
      "Auto grammar check",
      "Tab indexing"
    ],
    "answer": "Cells organized in rows and columns"
  },
  {
    "question": "Which of these is used to create database queries?",
    "options": [
      "Forms",
      "Tables",
      "SQL",
      "Reports"
    ],
    "answer": "SQL"
  },
  {
    "question": "Which HTML element is used for table rows?",
    "options": [
      "<tr>",
      "<td>",
      "<th>",
      "<row>"
    ],
    "answer": "<tr>"
  },
  {
    "question": "Which of the following is an anti-virus program?",
    "options": [
      "Microsoft Excel",
      "Adobe Reader",
      "Norton",
      "Mozilla Firefox"
    ],
    "answer": "Norton"
  },
  {
    "question": "Which of these connects multiple computers in a network?",
    "options": [
      "Switch",
      "Monitor",
      "Keyboard",
      "Scanner"
    ],
    "answer": "Switch"
  },
  {
    "question": "Which of these is an example of system software?",
    "options": [
      "Microsoft Word",
      "Google Chrome",
      "Operating System",
      "Photoshop"
    ],
    "answer": "Operating System"
  },
  {
    "question": "In HTML, what does <a> tag define?",
    "options": [
      "Paragraph",
      "Link",
      "Heading",
      "Table"
    ],
    "answer": "Link"
  },
  {
    "question": "What is a virus in computing?",
    "options": [
      "A software update",
      "A game application",
      "A malicious program",
      "A computer language"
    ],
    "answer": "A malicious program"
  },
  {
    "question": "Which programming term refers to a named storage for data?",
    "options": [
      "Function",
      "Loop",
      "Variable",
      "Object"
    ],
    "answer": "Variable"
  },
  {
    "question": "Which device is essential for internet connectivity?",
    "options": [
      "Scanner",
      "Modem",
      "Printer",
      "Flash drive"
    ],
    "answer": "Modem"
  },
  {
    "question": "In database, what is a record?",
    "options": [
      "A single field",
      "A group of tables",
      "A row of related data",
      "A chart"
    ],
    "answer": "A row of related data"
  },
  {
    "question": "Which of these is NOT a web browser?",
    "options": [
      "Chrome",
      "Firefox",
      "Safari",
      "Linux"
    ],
    "answer": "Linux"
  },
  {
    "question": "What does DTP stand for?",
    "options": [
      "Data Transfer Protocol",
      "Desktop Publishing",
      "Data Typing Program",
      "Digital Technical Processing"
    ],
    "answer": "Desktop Publishing"
  },
  {
    "question": "Which of the following allows conditional operations in spreadsheets?",
    "options": [
      "=TOTAL()",
      "=ADD()",
      "=IF()",
      "=CHOOSE()"
    ],
    "answer": "=IF()"
  },
  {
    "question": "Which of these is NOT a file extension?",
    "options": [
      ".docx",
      ".jpg",
      ".mp3",
      ".CPU"
    ],
    "answer": ".CPU"
  },
  {
    "question": "Which of the following is part of the input unit?",
    "options": [
      "Monitor",
      "Mouse",
      "Speaker",
      "Projector"
    ],
    "answer": "Mouse"
  },
  {
    "question": "Which HTML tag is used for a line break?",
    "options": [
      "<br>",
      "<lb>",
      "<break>",
      "<line>"
    ],
    "answer": "<br>"
  },
  {
    "question": "What is an algorithm?",
    "options": [
      "Computer part",
      "Set of instructions",
      "Graphic image",
      "Virus type"
    ],
    "answer": "Set of instructions"
  },
  {
    "question": "What does SQL stand for?",
    "options": [
      "System Query Language",
      "Structured Query Language",
      "Sequential Query Logic",
      "Standard Question Language"
    ],
    "answer": "Structured Query Language"
  },
  {
    "question": "What is the first step in the program development life cycle?",
    "options": [
      "Coding",
      "Problem identification",
      "Testing",
      "Maintenance"
    ],
    "answer": "Problem identification"
  },
  {
    "question": "What does the tag <h1> in HTML represent?",
    "options": [
      "Heading level 1",
      "Hyperlink",
      "Horizontal rule",
      "HTML start"
    ],
    "answer": "Heading level 1"
  },
  {
    "question": "Which is NOT a function of an operating system?",
    "options": [
      "Managing memory",
      "Running applications",
      "Browsing internet",
      "Managing files"
    ],
    "answer": "Browsing internet"
  },
  {
    "question": "Which of the following is a storage device?",
    "options": [
      "Monitor",
      "Hard disk",
      "Keyboard",
      "Modem"
    ],
    "answer": "Hard disk"
  },
  {
    "question": "Which tag in HTML is used to define a table row?",
    "options": [
      "<th>",
      "<td>",
      "<tr>",
      "<table>"
    ],
    "answer": "<tr>"
  },
  {
    "question": "Which device reads barcodes?",
    "options": [
      "Scanner",
      "Joystick",
      "Touchpad",
      "Microphone"
    ],
    "answer": "Scanner"
  },
  {
    "question": "In flowcharts, what shape represents a decision?",
    "options": [
      "Circle",
      "Square",
      "Diamond",
      "Rectangle"
    ],
    "answer": "Diamond"
  },
  {
    "question": "What is used to prevent unauthorized access to a computer network?",
    "options": [
      "Firewall",
      "Modem",
      "USB port",
      "Keyboard lock"
    ],
    "answer": "Firewall"
  },
  {
    "question": "Which of these is NOT a function of database management systems?",
    "options": [
      "Data storage",
      "Data retrieval",
      "Photo editing",
      "Data manipulation"
    ],
    "answer": "Photo editing"
  },
  {
    "question": "What does <img src='image.jpg'> do in HTML?",
    "options": [
      "Saves an image",
      "Links to an image",
      "Displays an image",
      "Edits an image"
    ],
    "answer": "Displays an image"
  },
  {
    "question": "Which of these is a volatile memory?",
    "options": [
      "Hard drive",
      "ROM",
      "SSD",
      "RAM"
    ],
    "answer": "RAM"
  },
  {
    "question": "Which is NOT a data type in spreadsheets?",
    "options": [
      "Text",
      "Number",
      "Audio",
      "Date"
    ],
    "answer": "Audio"
  },
  {
    "question": "Which utility program is used to organize files in storage?",
    "options": [
      "Disk Defragmenter",
      "Calculator",
      "Paint",
      "Task Manager"
    ],
    "answer": "Disk Defragmenter"
  },
  {
    "question": "What is the function of the CPU?",
    "options": [
      "Power supply",
      "Printing documents",
      "Processing data",
      "Displaying graphics"
    ],
    "answer": "Processing data"
  },
  {
    "question": "Which language is used to structure a website?",
    "options": [
      "HTML",
      "Python",
      "SQL",
      "Java"
    ],
    "answer": "HTML"
  },
  {
    "question": "Which of the following is an example of a multimedia tool in education?",
    "options": [
      "Whiteboard",
      "Chalk",
      "Projector",
      "Notebook"
    ],
    "answer": "Projector"
  },
  {
    "question": "What is an output of compiling a program?",
    "options": [
      "Source code",
      "Error report",
      "Executable file",
      "Algorithm"
    ],
    "answer": "Executable file"
  },
  {
    "question": "Which of these is NOT a valid HTML tag?",
    "options": [
      "<div>",
      "<body>",
      "<footer>",
      "<note>"
    ],
    "answer": "<note>"
  },
  {
    "question": "What is the purpose of using tables in DTP?",
    "options": [
      "Organize text and data",
      "Insert animations",
      "Add background music",
      "Execute scripts"
    ],
    "answer": "Organize text and data"
  },
  {
    "question": "Which of these is NOT a secondary storage device?",
    "options": [
      "Flash drive",
      "RAM",
      "DVD",
      "External hard drive"
    ],
    "answer": "RAM"
  },
  {
    "question": "Which of the following is a system maintenance tool?",
    "options": [
      "Browser",
      "Antivirus",
      "Video player",
      "Text editor"
    ],
    "answer": "Antivirus"
  },
  {
    "question": "What is flowchart used for?",
    "options": [
      "Drawing diagrams",
      "Designing slides",
      "Solving problems visually",
      "Formatting text"
    ],
    "answer": "Solving problems visually"
  },
  {
    "question": "Which component holds the BIOS?",
    "options": [
      "RAM",
      "Hard disk",
      "ROM",
      "CPU"
    ],
    "answer": "ROM"
  },
  {
    "question": "Which of these is a type of software license?",
    "options": [
      "Freeware",
      "Printerware",
      "Firmware",
      "Wormware"
    ],
    "answer": "Freeware"
  },
  {
    "question": "What tag is used to add a row in HTML table?",
    "options": [
      "<table>",
      "<row>",
      "<tr>",
      "<td>"
    ],
    "answer": "<tr>"
  },
  {
    "question": "What is a database form used for?",
    "options": [
      "Creating queries",
      "Entering and viewing data",
      "Designing reports",
      "Managing passwords"
    ],
    "answer": "Entering and viewing data"
  },
  {
    "question": "What does the <b> tag do in HTML?",
    "options": [
      "Break line",
      "Insert image",
      "Bold text",
      "Create table"
    ],
    "answer": "Bold text"
  },
  {
    "question": "Which of these is a benefit of networking?",
    "options": [
      "File sharing",
      "Increased power usage",
      "Less data security",
      "Higher printing costs"
    ],
    "answer": "File sharing"
  },
  {
    "question": "What does DPI stand for in printing?",
    "options": [
      "Dots Per Inch",
      "Digital Page Index",
      "Data Processing Information",
      "Document Print Input"
    ],
    "answer": "Dots Per Inch"
  },
  {
    "question": "Which of the following is a type of computer network?",
    "options": [
      "USB",
      "LAN",
      "CPU",
      "ROM"
    ],
    "answer": "LAN"
  },
  {
    "question": "What is data security?",
    "options": [
      "Deleting files",
      "Protecting data from threats",
      "Backing up only images",
      "Formatting computers"
    ],
    "answer": "Protecting data from threats"
  },
  {
    "question": "What is the full meaning of HTML?",
    "options": [
      "Hyper Transfer Media Language",
      "Hyper Text Markup Language",
      "Hyper Tool Markup Language",
      "High Text Machine Language"
    ],
    "answer": "Hyper Text Markup Language"
  },
  {
    "question": "Which tag is used to create a hyperlink in HTML?",
    "options": [
      "<link>",
      "<url>",
      "<a>",
      "<href>"
    ],
    "answer": "<a>"
  },
  {
    "question": "What is the use of 'Forms' in database applications?",
    "options": [
      "Create data charts",
      "Enter and view records easily",
      "Edit HTML",
      "Encrypt files"
    ],
    "answer": "Enter and view records easily"
  },
  {
    "question": "Which programming term defines a loop?",
    "options": [
      "For",
      "Def",
      "Var",
      "Print"
    ],
    "answer": "For"
  },
  {
    "question": "Which of the following is a markup language?",
    "options": [
      "C++",
      "HTML",
      "Python",
      "Java"
    ],
    "answer": "HTML"
  },
  {
    "question": "What is a Trojan horse?",
    "options": [
      "A database error",
      "A harmless file",
      "A malware disguised as a useful program",
      "A network protocol"
    ],
    "answer": "A malware disguised as a useful program"
  },
  {
    "question": "What is the primary function of RAM?",
    "options": [
      "Permanent storage",
      "Input processing",
      "Temporary data storage",
      "Network connection"
    ],
    "answer": "Temporary data storage"
  },
  {
    "question": "What shape represents input/output in a flowchart?",
    "options": [
      "Oval",
      "Diamond",
      "Parallelogram",
      "Rectangle"
    ],
    "answer": "Parallelogram"
  },
  {
    "question": "Which of the following is an example of spreadsheet software?",
    "options": [
      "MS Word",
      "MS Excel",
      "MS Access",
      "MS Paint"
    ],
    "answer": "MS Excel"
  },
  {
    "question": "Which software is mainly used for creating databases?",
    "options": [
      "MS Word",
      "MS Excel",
      "MS Access",
      "MS PowerPoint"
    ],
    "answer": "MS Access"
  },
  {
    "question": "Which network topology connects each computer to a central hub?",
    "options": [
      "Mesh",
      "Bus",
      "Star",
      "Ring"
    ],
    "answer": "Star"
  },
  {
    "question": "What does GUI stand for?",
    "options": [
      "Graphical User Interface",
      "General Use Interface",
      "Group User Interact",
      "Graphical Universal Interface"
    ],
    "answer": "Graphical User Interface"
  },
  {
    "question": "Which component allows permanent storage of data?",
    "options": [
      "RAM",
      "Cache",
      "Hard Disk",
      "Registers"
    ],
    "answer": "Hard Disk"
  },
  {
    "question": "Which of the following is used to prevent data loss?",
    "options": [
      "Formatting",
      "Defragmentation",
      "Backup",
      "Compression"
    ],
    "answer": "Backup"
  },
  {
    "question": "Which programming stage includes writing the actual code?",
    "options": [
      "Planning",
      "Design",
      "Implementation",
      "Testing"
    ],
    "answer": "Implementation"
  },
  {
    "question": "Which of the following HTML elements is used to insert a line?",
    "options": [
      "<line>",
      "<hr>",
      "<br>",
      "<div>"
    ],
    "answer": "<hr>"
  },
  {
    "question": "What is the role of antivirus software?",
    "options": [
      "To update the OS",
      "To manage files",
      "To protect against malware",
      "To compress videos"
    ],
    "answer": "To protect against malware"
  },
  {
    "question": "What feature allows one to copy formatting in a spreadsheet?",
    "options": [
      "AutoFill",
      "Format Painter",
      "Filter",
      "Sort"
    ],
    "answer": "Format Painter"
  },
  {
    "question": "Which of the following is a function in spreadsheet software?",
    "options": [
      "=WORD()",
      "=WRITE()",
      "=SUM()",
      "=DOC()"
    ],
    "answer": "=SUM()"
  },
  {
    "question": "Which HTML tag creates an unordered list?",
    "options": [
      "<ul>",
      "<ol>",
      "<li>",
      "<list>"
    ],
    "answer": "<ul>"
  },
  {
    "question": "Which of these is used to develop web applications?",
    "options": [
      "Excel",
      "Python",
      "HTML",
      "Access"
    ],
    "answer": "HTML"
  },
  {
    "question": "What is phishing?",
    "options": [
      "Virus removal",
      "Installing software",
      "Fraudulent attempt to get user data",
      "Website blocking"
    ],
    "answer": "Fraudulent attempt to get user data"
  },
  {
    "question": "Which of these is used for database queries?",
    "options": [
      "Forms",
      "Reports",
      "SQL",
      "Charts"
    ],
    "answer": "SQL"
  },
  {
    "question": "What does the <p> tag define in HTML?",
    "options": [
      "Page",
      "Paragraph",
      "Picture",
      "Port"
    ],
    "answer": "Paragraph"
  },
  {
    "question": "Which device is used to display hardcopy of documents?",
    "options": [
      "Projector",
      "Printer",
      "Monitor",
      "Plotter"
    ],
    "answer": "Printer"
  },
  {
    "question": "Which of these is a programming language?",
    "options": [
      "Photoshop",
      "Word",
      "Python",
      "Excel"
    ],
    "answer": "Python"
  },
  {
    "question": "Which software is best for slide presentations?",
    "options": [
      "MS Access",
      "MS PowerPoint",
      "MS Excel",
      "MS Word"
    ],
    "answer": "MS PowerPoint"
  },
  {
    "question": "What is the use of tags in HTML?",
    "options": [
      "Add music",
      "Define document structure",
      "Execute files",
      "Encrypt pages"
    ],
    "answer": "Define document structure"
  },
  {
    "question": "What does ISP stand for?",
    "options": [
      "Internet Service Provider",
      "International Service Program",
      "Internal Security Protocol",
      "Input System Package"
    ],
    "answer": "Internet Service Provider"
  },
  {
    "question": "Which of these formats is best for image files?",
    "options": [
      ".docx",
      ".jpg",
      ".xls",
      ".ppt"
    ],
    "answer": ".jpg"
  },
  {
    "question": "Which of these protects user data on the internet?",
    "options": [
      "Firewall",
      "Modem",
      "Router",
      "Monitor"
    ],
    "answer": "Firewall"
  },
  {
    "question": "Which language is used for creating algorithms?",
    "options": [
      "HTML",
      "Pseudocode",
      "CSS",
      "WYSIWYG"
    ],
    "answer": "Pseudocode"
  },
  {
    "question": "Which device connects multiple computers in a network?",
    "options": [
      "Printer",
      "Switch",
      "Mouse",
      "Scanner"
    ],
    "answer": "Switch"
  },
  {
    "question": "Which of the following is an example of primary memory?",
    "options": [
      "SSD",
      "RAM",
      "CD-ROM",
      "USB"
    ],
    "answer": "RAM"
  },
  {
    "question": "Which of the following tags is used to create headings in HTML?",
    "options": [
      "<head>",
      "<h1> to <h6>",
      "<title>",
      "<heading>"
    ],
    "answer": "<h1> to <h6>"
  },
  {
    "question": "Which of these allows visual representation of programming logic?",
    "options": [
      "Spreadsheet",
      "Database",
      "Flowchart",
      "Slide"
    ],
    "answer": "Flowchart"
  },
  {
    "question": "What does the term �debugging� refer to?",
    "options": [
      "Upgrading a system",
      "Removing errors from a program",
      "Buying a new PC",
      "Compiling code"
    ],
    "answer": "Removing errors from a program"
  },
  {
    "question": "Which input device is best for entering text?",
    "options": [
      "Mouse",
      "Scanner",
      "Keyboard",
      "Microphone"
    ],
    "answer": "Keyboard"
  },
  {
    "question": "Which application is commonly used for DTP?",
    "options": [
      "CorelDRAW",
      "Notepad",
      "Excel",
      "Command Prompt"
    ],
    "answer": "CorelDRAW"
  },
  {
    "question": "Which of these is an anti-virus software?",
    "options": [
      "Google Drive",
      "MS Word",
      "Norton",
      "Photoshop"
    ],
    "answer": "Norton"
  },
  {
    "question": "What kind of network spans a city?",
    "options": [
      "LAN",
      "MAN",
      "WAN",
      "PAN"
    ],
    "answer": "MAN"
  },
  {
    "question": "What does the 'Print Preview' feature do?",
    "options": [
      "Saves the document",
      "Shows how the document will look when printed",
      "Edits document layout",
      "Converts to PDF"
    ],
    "answer": "Shows how the document will look when printed"
  },
  {
    "question": "Which device is used for voice input?",
    "options": [
      "Speaker",
      "Microphone",
      "Monitor",
      "Printer"
    ],
    "answer": "Microphone"
  },
  {
    "question": "Which HTML tag is used to insert images?",
    "options": [
      "<img>",
      "<pic>",
      "<src>",
      "<photo>"
    ],
    "answer": "<img>"
  },
  {
    "question": "What does DTP mainly deal with?",
    "options": [
      "Data processing",
      "Publishing printed materials",
      "Programming",
      "Web designing"
    ],
    "answer": "Publishing printed materials"
  },
  {
    "question": "Which of these is used to identify a website?",
    "options": [
      "IP Address",
      "URL",
      "ROM",
      "BIOS"
    ],
    "answer": "URL"
  },
  {
    "question": "What is the main use of charts in spreadsheets?",
    "options": [
      "Write code",
      "Draw pictures",
      "Graphically represent data",
      "Type essays"
    ],
    "answer": "Graphically represent data"
  },
  {
    "question": "Which of the following languages is used for web structure?",
    "options": [
      "CSS",
      "HTML",
      "Python",
      "C"
    ],
    "answer": "HTML"
  }
];
export default electiveictQuestions;